import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { AppService } from "../services/app.service";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { DatePipe } from "@angular/common";
import { environment } from "../../environments/environment";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { Router } from "@angular/router";
import { IMyDpOptions } from "mydatepicker";
import { KeyValue } from "@angular/common";
import { SupportService } from "../services/support-service";

@Component({
  selector: "app-basicinfo",
  templateUrl: "./basicinfo.component.html",
  styleUrls: ["./basicinfo.component.scss"],
  styles: [
    `
      :host >>> .tooltip-inner {
        background-color: #00b0f0;
        color: #ffffff;
      }
      :host >>> .tooltip.top .tooltip-arrow:before,
      :host >>> .tooltip.top .tooltip-arrow {
        border-top-color: #00b0f0;
      }
    `,
  ],
})
export class BasicinfoComponent implements OnInit {
  testCenter: any;
  profileErrorMessage: string;
  modalRef: BsModalRef;
  @ViewChild("changepwdpopup") changepwdpopup: TemplateRef<any>;
  @ViewChild("notRangePopup") notRangePopup: TemplateRef<any>;
  @ViewChild("workinghourspopup") workinghourspopup: TemplateRef<any>;
  @ViewChild("validationPopup") validationPopup: TemplateRef<any>;
  @ViewChild("backendissuePopup") backendissuePopup: TemplateRef<any>;
  @ViewChild("unverifiedPopup") unverifiedPopup: TemplateRef<any>;
  @ViewChild("yesornoPopup") yesornoPopup: TemplateRef<any>;

  public panPattern: boolean;

  testCenterinfo: FormGroup;
  changepassword: FormGroup;
  testCenterinfosubmit = false;
  countryList: any;
  generalvalidationMessage: string;
  changepwdsubmited: boolean;
  stateList: any;
  visibleHoliday: boolean;
  compareHrsValid = false;
  parkingList: any;
  holidayList: any;
  allYears: any = [];
  today = new Date();
  currentDate: number;
  currentMonth: number;
  currentYear: number;
  heading: string;
  hoursList: any;
  type: string;
  fromUrl: any;
  addressId: any;
  config = {
    ignoreBackdropClick: true,
  };
  yesornoPopuptype = "";
  fromTimeArray = environment.initialTime;
  testCenterId: any = localStorage.getItem("testCenterId");
  infoText = "Info";
  public myDatePickerOptions: IMyDpOptions = {};
  ziplength = 0;
  ziperror = false;
  zipmask = "";
  ziplabel = "";
  formValueChange = false;
  errtab: number = this.today.getFullYear();
  profileUpdateMessage = "";
  updateTestCenter = false;
  disableUpdate = false;
  changepasswordmessage: any = "";
  changepasswordflag = 0;
  workinghoursmessage: any = "";
  tempworkinghourList: any = [];
  wrkhoursList: any = [];
  lunchhoursList: any = [];
  usertype = "";
  navigateURL = "";
  validationMessage: any = {};
  basicinfotext: any = {};
  resettext: any = {};
  signintext: any = {};
  backendIssue: any = "";
  unverifiedMsg: any = "";
  backendstatuscode: any = "";
  nextYear: any;
  patientTextEmailContent = false;
  businessDaysWrkList: Map<number, Record<string, any>> =
    this.buildDefaultBusinessDaysWrkList();

  lat: number;
  lng: number;
  locationmessage: any = "";
  secondaryEamilList = [];
  selectedIndex = 0;
  newholidaylist = [];
  primaryphonemask = "";
  alternativephonemask = "";
  faxphonemask = "";
  contactprimary = "";
  contactsecondary = "";
  primaryInfoPhoneMask = "";
  panMask = "";
  secondaryInfoPhoneMask = "";
  tabList = [
    { heading: this.today.getFullYear() },
    { heading: this.today.getFullYear() + 1 },
    { heading: this.today.getFullYear() + 2 },
  ];
  selectedYear: number = this.today.getFullYear();
  cityList: any = [];
  passwordview: any = "password";
  confirmpasswordview: any = "password";
  newpasswordview: any = "password";
  
  

  keyAscOrder = (
    a: KeyValue<number, Record<string, any>>,
    b: KeyValue<number, Record<string, any>>
  ): number => {
    return a.key < b.key ? -1 : b.key < a.key ? 1 : 0;
  };

  constructor(
    private appservice: AppService,
    private TCInfo: FormBuilder,
    private datepipe: DatePipe,
    private modalService: BsModalService,
    private router: Router,
    private supportService: SupportService
  ) {
    this.panPattern = false;
    this.currentDate = this.today.getDate() - 1;
    this.currentMonth = this.today.getMonth() + 1;
    this.currentYear = this.today.getFullYear();
    this.allYears.push(this.currentYear);
    this.allYears.push(this.today.getFullYear() + 1);
    this.allYears.push(this.today.getFullYear() + 2);
    this.myDatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      minYear: +this.currentYear,
      firstDayOfWeek: "su",
      disableUntil: {
        year: +this.currentYear,
        month: +this.currentMonth,
        day: +this.currentDate,
      },
      maxYear: +this.currentYear,
      showClearDateBtn: false,
      editableDateField: false,
    };
    this.testCenter = {};
    this.testCenterinfo = TCInfo.group({
      testcentername: ["", [Validators.required]],
      address1: ["", [Validators.required]],
      unitoraddress2: [""],
      city: ["", [Validators.required]],
      state: ["default"],
      country: ["default"],
      ein: [""],
      nipId: ["", Validators.required],
      zipcode: ["", Validators.required],
      dateEnrolled: [{ value: "", disabled: true }, Validators.required],
      taxNumber: ["", Validators.required],
      panNumber: [""],
      areaName: ["", Validators.required],
      primaryEmail: [
        "",
        [Validators.required, Validators.pattern(environment.emailPattern)],
      ],
      mainEmail: [
        { value: "", disabled: true },
        [Validators.required, Validators.pattern(environment.emailPattern)],
      ],
      primarycountrydialcode: ["default"],
      primaryphonenumber: [
        { value: "", disabled: true },
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      primaryphonenumberextncode: [""],
      alternativecountrydialcode: ["default"],
      alternativephonenumber: [
        { value: "", disabled: true },
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      alternativephonenumberextncode: [""],
      faxcountrydialcode: ["default"],
      faxnumber: [
        { value: "", disabled: true },
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      faxnumberextncode: [""],
      contactprimaryfirstName: ["", Validators.required],
      contactprimarylastName: ["", Validators.required],
      contactsecondaryfirstName: [""],
      contactsecondarylastName: [""],
      aboutus: [""],
      contactprimaryareaCode: ["default"],
      contactprimaryphoneNumber: [
        { value: "", disabled: true },
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      contactprimaryphoneNumberDialCode: [""],
      contactsecondaryareaCode: ["default"],
      contactsecondaryphoneNumber: [
        { value: "", disabled: true },
        [
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      contactsecondaryphoneNumberDialCode: [""],
      crossStreet: [""],
      description: [""],
      parking: ["default"],
      testCenterUrl: ["", [Validators.pattern(environment.websitePattern)]],
      faceBookUrl: [""],
      twitterUrl: [""],
      instagramUrl:[""],
      linkedInUrl:["",],
      newpassword: ["", [Validators.pattern(environment.passwordPattern)]],
      oldPassword: ["", [Validators.pattern(environment.passwordPattern)]],
      confirmpassword: [""],
      primaryinitial: ["", [Validators.required]],
      secondaryInitial: [""],
    });
    this.changepwdsubmited = false;
    this.countryList = [];
    this.stateList = [];
    this.visibleHoliday = false;
    this.parkingList = [];
    this.holidayList = [];
    this.addressId = "";
    this.hoursList = [];
  }

  setTestCenterName(value) {
    this.supportService.testCenterName.next(value);
    this.supportService.testCenterNameDropdown.next(value);
  }

  isIndiaCountry(countryId): boolean {
    return countryId == 1 || countryId == "1" || countryId == 101 || countryId == "101";
  }

  isUnitedStatesCountry(countryId): boolean {
    return countryId == 2 || countryId == "2" || countryId == 231 || countryId == "231";
  }

  checkziplength(event) {
    if (event && event.length != this.ziplength) {
      this.ziperror = true;
    } else {
      this.ziperror = false;
    }
  }

  panInput(event: any) {
    if(event.length == 10 ) {
      this.panPattern = false;
    } else {
      this.panPattern = true;
    }

  }

  canDeactivate(): Promise<boolean> | boolean {
    if (!this.formValueChange) return true;
    this.heading = "Info";
    this.generalvalidationMessage =
      "Are you sure you want to continue? Any unsaved changes will be lost.";
    this.yesornoPopuptype = "unsaved";
    this.openModal(this.yesornoPopup);
  }

  backtoimagingcenter() {
    if (this.usertype == "1" && this.navigateURL == "manageic") {
      this.router.navigate([
        localStorage.getItem("testCode").toString().trim(),
        "manage-imaging-center",
      ]);
    } else if (this.usertype == "1") {
      this.router.navigate([
        localStorage.getItem("testCode").toString().trim(),
        "imaging",
      ]);
    }
  }

  yesButtononPopup() {
    if (this.yesornoPopuptype == "changepwd") {
      this.logout();
    }
    if (this.yesornoPopuptype == "secondaryemail") {
      this.secondaryEamilList.splice(this.selectedIndex, 1);
      this.closemodel();
    }
    if (this.yesornoPopuptype == "hourslist") {
      this.hoursList.splice(this.selectedIndex, 1);
      if (this.hoursList && this.hoursList.length > 0) {
        this.wrkhoursList = [];
        this.lunchhoursList = [];
        for (let h = 0; h < this.hoursList.length; h++) {
          if (this.hoursList[h].monDay) {
            if (this.hoursList[h].workHourType == "work") {
              this.wrkhoursList.push({ type: "mon", index: h });
            }
            if (this.hoursList[h].workHourType == "lunch") {
              this.lunchhoursList.push({ type: "mon", index: h });
            }
          }
          if (this.hoursList[h].tueDay) {
            if (this.hoursList[h].workHourType == "work") {
              this.wrkhoursList.push({ type: "tue", index: h });
            }
            if (this.hoursList[h].workHourType == "lunch") {
              this.lunchhoursList.push({ type: "tue", index: h });
            }
          }
          if (this.hoursList[h].wedDay) {
            if (this.hoursList[h].workHourType == "work") {
              this.wrkhoursList.push({ type: "wed", index: h });
            }
            if (this.hoursList[h].workHourType == "lunch") {
              this.lunchhoursList.push({ type: "wed", index: h });
            }
          }
          if (this.hoursList[h].thuDay) {
            if (this.hoursList[h].workHourType == "work") {
              this.wrkhoursList.push({ type: "tue", index: h });
            }
            if (this.hoursList[h].workHourType == "lunch") {
              this.lunchhoursList.push({ type: "thu", index: h });
            }
          }
          if (this.hoursList[h].friDay) {
            if (this.hoursList[h].workHourType == "work") {
              this.wrkhoursList.push({ type: "fri", index: h });
            }
            if (this.hoursList[h].workHourType == "lunch") {
              this.lunchhoursList.push({ type: "fri", index: h });
            }
          }
          if (this.hoursList[h].satDay) {
            if (this.hoursList[h].workHourType == "work") {
              this.wrkhoursList.push({ type: "sat", index: h });
            }
            if (this.hoursList[h].workHourType == "lunch") {
              this.lunchhoursList.push({ type: "sat", index: h });
            }
          }
          if (this.hoursList[h].sunDay) {
            if (this.hoursList[h].workHourType == "work") {
              this.wrkhoursList.push({ type: "sun", index: h });
            }
            if (this.hoursList[h].workHourType == "lunch") {
              this.lunchhoursList.push({ type: "sun", index: h });
            }
          }
        }
      }
      this.businessDaysWrkList = this.buildDefaultBusinessDaysWrkList();
      this.createWrkingList(this.hoursList);
      this.closemodel();
    }
    if (
      this.yesornoPopuptype == "holidaylist" &&
      this.newholidaylist &&
      this.newholidaylist.length > 0
    ) {
      this.newholidaylist.splice(this.selectedIndex, 1);
      this.closemodel();
    }
    if (
      this.yesornoPopuptype == "originalHolidayList" &&
      this.holidayList &&
      this.holidayList.length > 0
    ) {
      this.holidayList[this.selectedIndex].active = false;
      this.closemodel();
    }
    if (this.yesornoPopuptype == "unsaved") {
      this.formValueChange = false;
      this.closemodel();
      this.router.navigate([
        localStorage.getItem("testCode").toString().trim(),
        "equipments",
      ]);
    }
  }

  noButtononPopup() {
    if (this.yesornoPopuptype == "changepwd") {
      this.noLogout();
      this.scrollTop("scrollme");
    } else {
      this.closemodel();
    }
  }

  saveBasicProfile(testCenterinfo, flag, changepassword) {
    if (
      this.testCenterinfo.valid &&
      flag &&
      this.testCenterinfo.get("state").value != "default"
    ) {
      if (this.newholidaylist.length > 0) {
        for (let index = 0; index < this.newholidaylist.length; index++) {
          if (
            this.newholidaylist[index].holidayName &&
            this.newholidaylist[index].holidayDate &&
            this.newholidaylist[index].holidayDate.date &&
            this.newholidaylist[index].holidayDate.date.year
          ) {
            const date =
              this.newholidaylist[index].holidayDate.date.year +
              "-" +
              this.chkLength(
                this.newholidaylist[index].holidayDate.date.month
              ) +
              "-" +
              this.chkLength(this.newholidaylist[index].holidayDate.date.day);
            const finalList = {
              active: true,
              countryId: this.newholidaylist[index].countryId,
              holidayDate: date,
              holidayStrDate: date,
              holidayDefault: false,
              holidayName: this.newholidaylist[index].holidayName,
              holidayDateStr: this.newholidaylist[index].holidayName,
              holidayYear: this.newholidaylist[index].holidayYear,
              closed: this.newholidaylist[index].closed,
            };
            this.holidayList.push(finalList);
          }
        }
        this.newholidaylist = [];
      }

      let stateid = 0;
      for (let index = 0; index < this.stateList.length; index++) {
        if (
          this.stateList[index].stateCode ==
          this.testCenterinfo.controls["state"].value
        ) {
          stateid = this.stateList[index].id;
          break;
        }
      }

      let address = {};
      if (this.addressId) {
        address = {
          id: this.testCenter.address.id,
          street: "",
          addressLine1: this.testCenterinfo.controls["address1"].value,
          addressLine2: this.testCenterinfo.controls["unitoraddress2"].value,
          areaName:
            this.isUnitedStatesCountry(this.testCenterinfo.controls["country"].value)
              ? this.testCenterinfo.controls["city"].value
              : this.testCenterinfo.controls["areaName"].value,
          cityName: this.testCenterinfo.controls["city"].value,
          state: {
            id: stateid,
          },
          country: {
            id: this.testCenterinfo.controls["country"].value,
          },
          zipCode: this.testCenterinfo.controls["zipcode"].value,
        };
      } else {
        address = {
          street: "",
          addressLine1: this.testCenterinfo.controls["address1"].value,
          addressLine2: this.testCenterinfo.controls["unitoraddress2"].value,
          areaName: this.testCenterinfo.controls["areaName"].value,
          cityName: this.testCenterinfo.controls["city"].value,
          state: {
            id: stateid,
          },
          country: {
            id: this.testCenterinfo.controls["country"].value,
          },
          zipCode: this.testCenterinfo.controls["zipcode"].value,
        };
      }

      let primarycontactinfo = {};
      if (this.testCenter.primaryContactInfo) {
        primarycontactinfo = {
          id: this.testCenter.primaryContactInfo.id,
          firstName: this.testCenterinfo.controls["contactprimaryfirstName"]
            .value,
          lastName: this.testCenterinfo.controls["contactprimarylastName"]
            .value,
          phoneNumber: this.testCenterinfo.controls["contactprimaryphoneNumber"]
            .value,
          phoneCode: this.testCenterinfo.controls["contactprimaryareaCode"]
            .value,
          phoneExtn: this.testCenterinfo.controls[
            "contactprimaryphoneNumberDialCode"
          ].value,
          active: true,
          deleted: false,
          initial: this.testCenterinfo.controls["primaryinitial"].value,
        };
      } else if (!this.testCenter.primaryContactInfo) {
        primarycontactinfo = {
          firstName: this.testCenterinfo.controls["contactprimaryfirstName"]
            .value,
          lastName: this.testCenterinfo.controls["contactprimarylastName"]
            .value,
          phoneNumber: this.testCenterinfo.controls["contactprimaryphoneNumber"]
            .value,
          phoneCode: this.testCenterinfo.controls["contactprimaryareaCode"]
            .value,
          phoneExtn: this.testCenterinfo.controls[
            "contactprimaryphoneNumberDialCode"
          ].value,
          active: true,
          deleted: false,
          initial: this.testCenterinfo.controls["primaryinitial"].value,
        };
      }

      let secondarcontactinfo = {};
      if (this.testCenter.secondaryContactInfo) {
        secondarcontactinfo = {
          id: this.testCenter.secondaryContactInfo.id,
          firstName: this.testCenterinfo.controls["contactsecondaryfirstName"]
            .value,
          lastName: this.testCenterinfo.controls["contactsecondarylastName"]
            .value,
          phoneNumber: this.testCenterinfo.controls[
            "contactsecondaryphoneNumber"
          ].value,
          phoneCode: this.testCenterinfo.controls["contactsecondaryareaCode"]
            .value,
          phoneExtn: this.testCenterinfo.controls[
            "contactsecondaryphoneNumberDialCode"
          ].value,
          active: true,
          deleted: false,
          initial: this.testCenterinfo.controls["secondaryInitial"].value,
        };
      } else if (!this.testCenter.secondaryContactInfo) {
        secondarcontactinfo = {
          firstName: this.testCenterinfo.controls["contactsecondaryfirstName"]
            .value,
          lastName: this.testCenterinfo.controls["contactsecondarylastName"]
            .value,
          phoneNumber: this.testCenterinfo.controls[
            "contactsecondaryphoneNumber"
          ].value,
          phoneCode: this.testCenterinfo.controls["contactsecondaryareaCode"]
            .value,
          phoneExtn: this.testCenterinfo.controls[
            "contactsecondaryphoneNumberDialCode"
          ].value,
          active: true,
          deleted: false,
          initial: this.testCenterinfo.controls["secondaryInitial"].value,
        };
      }
      const parking =
        this.testCenterinfo.controls["parking"].value == "default"
          ? null
          : { id: this.testCenterinfo.controls["parking"].value };

      let timeZoneId = "";
      let timeZoneName = "";
      this.saveProfile(
        address,
        primarycontactinfo,
        secondarcontactinfo,
        parking,
        timeZoneId,
        timeZoneName,
        changepassword
      );
      if (this.lat && this.lng) {
        this.appservice.getTimeZoneByLatLng(this.lat, this.lng).subscribe(
          (res) => {
            if (res && res["status"] == "OK") {
              timeZoneId = res["timeZoneId"];
              timeZoneName = res["timeZoneName"];

              this.saveProfile(
                address,
                primarycontactinfo,
                secondarcontactinfo,
                parking,
                timeZoneId,
                timeZoneName,
                changepassword
              );
            }
          },
          (err) => ({})
        );
      }
    } else {
      if (
        this.testCenterinfo.controls["primaryEmail"].value &&
        this.testCenterinfosubmit
      ) {
        if (
          !this.emailPatternValidation(
            this.testCenterinfo.controls["primaryEmail"].value
          )
        ) {
          this.validationMessage.primaryEmailValidationmessage = this.validationMessage.validEmail;
        } else {
          this.validationMessage.primaryEmailValidationmessage = "";
        }
      } else if (
        this.testCenterinfosubmit &&
        !this.testCenterinfo.controls["primaryEmail"].value
      ) {
        this.validationMessage.primaryEmailValidationmessage = this.validationMessage.emailid;
      }

      this.primaryphonenumberValidationMessage();

      this.alternativephoneNumberValidationMessage();

      this.faxNumberValidationMessage();

      this.contactprimaryValidationMessage();

      this.contactsecValidationMessage();

      this.profileUpdateMessage = "";
      this.profileErrorMessage =
        "Please address the highlighted areas, then try again";
      setTimeout(() => {
        this.profileErrorMessage = "";
        this.profileUpdateMessage = "";
      }, 5000);
      this.updateTestCenter = false;
      this.disableUpdate = true;
    }
  }

  saveProfile(
    address,
    primarycontactinfo,
    secondarcontactinfo,
    parking,
    timeZoneId,
    timeZoneName,
    changepassword
  ) {
    let data;
    if (sessionStorage.getItem("usertype") == "1") {
      data = {
        tcId: this.testCenterId,
        name: this.testCenterinfo.controls["testcentername"].value,
        address: address,
        taxId: this.testCenterinfo.controls["taxNumber"].value,
        nipId: this.testCenterinfo.controls["nipId"].value,
        primaryNumber: this.testCenterinfo.controls["primaryphonenumber"].value,
        alternativeNumber: this.testCenterinfo.controls[
          "alternativephonenumber"
        ].value,
        alternativeExtn: this.testCenterinfo.controls[
          "alternativephonenumberextncode"
        ].value,
        faxNumber: this.testCenterinfo.controls["faxnumber"].value,
        faxExtn: this.testCenterinfo.controls["faxnumberextncode"].value,
        primaryCode: this.testCenterinfo.controls["primarycountrydialcode"]
          .value,
        alternativeCode: this.testCenterinfo.controls[
          "alternativecountrydialcode"
        ].value,
        primaryExtn: this.testCenterinfo.controls["primaryphonenumberextncode"]
          .value,
        faxCode: this.testCenterinfo.controls["faxcountrydialcode"].value,
        primaryContactInfo: primarycontactinfo,
        secondaryContactInfo: secondarcontactinfo,
        crossStreet: this.testCenterinfo.controls["crossStreet"].value,
        publicTransport: this.testCenterinfo.controls["description"].value,
        parking: parking,
        websiteUrl: this.testCenterinfo.controls["testCenterUrl"].value,
        fbUrl: this.testCenterinfo.controls["faceBookUrl"].value,
        twitterUrl: this.testCenterinfo.controls["twitterUrl"].value,
        instagramUrl: this.testCenterinfo.controls["instagramUrl"].value,
        linkedInUrl: this.testCenterinfo.controls["linkedInUrl"].value,
        latitude: this.lat,
        longitude: this.lng,
        businessHour: false,
        procedureDuration: false,
        technicianAvailability: false,
        insuranceAccepted: false,
        workingHours: this.hoursList,
        mainEmail: this.testCenterinfo.controls["mainEmail"].value,
        tcEmail: this.testCenterinfo.controls["primaryEmail"].value,
        secondaryEmail: this.secondaryEamilList,
        tcHolidays: this.holidayList,
        active: true,
        deleted: false,
        timeZoneId: timeZoneId,
        timeZoneName: timeZoneName,
        adminUpdate: true,
      };
    } else {
      data = {
        tcId: this.testCenterId,
        name: this.testCenterinfo.controls["testcentername"].value,
        address: address,
        taxId: this.testCenterinfo.controls["taxNumber"].value,
        nipId: this.testCenterinfo.controls["nipId"].value,
        primaryNumber: this.testCenterinfo.controls["primaryphonenumber"].value,
        alternativeNumber: this.testCenterinfo.controls[
          "alternativephonenumber"
        ].value,
        alternativeExtn: this.testCenterinfo.controls[
          "alternativephonenumberextncode"
        ].value,
        faxNumber: this.testCenterinfo.controls["faxnumber"].value,
        faxExtn: this.testCenterinfo.controls["faxnumberextncode"].value,
        primaryCode: this.testCenterinfo.controls["primarycountrydialcode"]
          .value,
        alternativeCode: this.testCenterinfo.controls[
          "alternativecountrydialcode"
        ].value,
        primaryExtn: this.testCenterinfo.controls["primaryphonenumberextncode"]
          .value,
        faxCode: this.testCenterinfo.controls["faxcountrydialcode"].value,
        primaryContactInfo: primarycontactinfo,
        secondaryContactInfo: secondarcontactinfo,
        crossStreet: this.testCenterinfo.controls["crossStreet"].value,
        publicTransport: this.testCenterinfo.controls["description"].value,
        parking: parking,
        websiteUrl: this.testCenterinfo.controls["testCenterUrl"].value,
        fbUrl: this.testCenterinfo.controls["faceBookUrl"].value,
        instagramUrl: this.testCenterinfo.controls["instagramUrl"].value,
        linkedInUrl: this.testCenterinfo.controls["linkedInUrl"].value,
        aboutUs: this.testCenterinfo.controls["aboutus"].value,
        twitterUrl: this.testCenterinfo.controls["twitterUrl"].value,
        latitude: this.lat,
        longitude: this.lng,
        businessHour: false,
        procedureDuration: false,
        technicianAvailability: false,
        insuranceAccepted: false,
        workingHours: this.hoursList,
        mainEmail: this.testCenterinfo.controls["mainEmail"].value,
        tcEmail: this.testCenterinfo.controls["primaryEmail"].value,
        secondaryEmail: this.secondaryEamilList,
        tcHolidays: this.holidayList,
        active: true,
        deleted: false,
        timeZoneId: timeZoneId,
        timeZoneName: timeZoneName,
      };
    }

    this.appservice.updateBasicProfile(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] == 200) {
          this.formValueChange = false;
          if (changepassword) {
            this.heading = "Change Password";
            this.generalvalidationMessage =
              "Password Changed successfully, Do you want to Logout?";
            this.yesornoPopuptype = "changepwd";
            this.openModal(this.yesornoPopup);
          } else {
            this.profileErrorMessage = "";
            this.profileUpdateMessage = this.basicinfotext.updatedSuccessfully;
            setTimeout(() => {
              this.profileUpdateMessage = "";
            }, 5000);
            this.scrollTop("scrollme");
            this.viewTestCenter();
          }

          // if (!this.patientTextEmailContent) {
          //   this.savePatientTextEmailMessage();
          // }

          if (
            this.usertype == "2" &&
            localStorage.getItem("subscriptionflag") != null &&
            localStorage.getItem("subscriptionflag") == "false"
          ) {
            setTimeout(() => {
              this.router.navigate([
                localStorage.getItem("testCode").toString().trim(),
                "equipments",
              ]);
            }, 1500);
          }

          // if(this.usertype =='1' && this.type =='dashboard'){
          //   this.router.navigate([localStorage.getItem("testCode").toString().trim(), 'imaging']);
          // }
          // if(this.usertype =='1' && this.type =="manage-imaging-center"){
          //   this.router.navigate([localStorage.getItem("testCode").toString().trim(), 'manage-imaging-center']);
          // }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  savePatientTextEmailMessage() {
    const data = [
      {
        id: "",
        text: "9 PM sms alert for your schedule",
        type: "text",
        preauthorization: true,
        scheduleType: "Every 9 PM",
        testCenterId: localStorage.getItem("testCenterId"),
        threshold: 0,
      },
      {
        id: "",
        text: "9 PM email alert for your schedule",
        type: "email",
        preauthorization: true,
        scheduleType: "Every 9 PM",
        testCenterId: localStorage.getItem("testCenterId"),
        threshold: 0,
      },
      {
        id: "",
        text: "9 AM sms alert for your schedule",
        type: "email",
        preauthorization: true,
        scheduleType: "Every 9 AM",
        testCenterId: localStorage.getItem("testCenterId"),
        threshold: 0,
      },
      {
        id: "",
        text: "Two hours before sms alert for your schedule",
        type: "text",
        preauthorization: true,
        scheduleType: "today",
        testCenterId: localStorage.getItem("testCenterId"),
        threshold: 2,
      },
      {
        id: "",
        text: "one hours before sms alert for your schedule",
        type: "text",
        preauthorization: true,
        scheduleType: "today",
        testCenterId: localStorage.getItem("testCenterId"),
        threshold: 1,
      },
      {
        id: "",
        text: "one hours before email alert for your schedule",
        type: "email",
        preauthorization: true,
        scheduleType: "today",
        testCenterId: localStorage.getItem("testCenterId"),
        threshold: 1,
      },
    ];

    this.appservice
      .savepatientTextMessage({ ptInputs: data })
      .subscribe((res) => {
        if (res["entity"] && res["entity"].length > 0) {
          this.patientTextEmailContent = true;
        }
      });
  }

  primaryphonenumberValidationMessage() {
    if (
      this.testCenterinfo.controls["primaryphonenumber"].value &&
      this.testCenterinfosubmit
    ) {
      if (this.testCenterinfo.get("primaryphonenumber").hasError("minlength")) {
        this.validationMessage.primaryphonenumbermessage = this.validationMessage.phonemaxlengthvalidmessage;
      } else if (
        this.testCenterinfo.get("primaryphonenumber").hasError("maxlength")
      ) {
        this.validationMessage.primaryphonenumbermessage = this.validationMessage.phonemaxlengthvalidmessage;
      } else {
        this.validationMessage.primaryphonenumbermessage = "";
      }
    } else if (
      this.testCenterinfosubmit &&
      !this.testCenterinfo.controls["primaryphonenumber"].value
    ) {
      this.validationMessage.primaryphonenumbermessage =
        "Phone number is requied";
    } else {
      this.validationMessage.primaryphonenumbermessage = "";
    }
  }

  alternativephoneNumberValidationMessage() {
    if (
      this.testCenterinfo.controls["alternativephonenumber"].value &&
      this.testCenterinfosubmit
    ) {
      if (
        this.testCenterinfo.get("alternativephonenumber").hasError("minlength")
      ) {
        this.validationMessage.alternativephonenumbermessage = this.validationMessage.phonemaxlengthvalidmessage;
      } else if (
        this.testCenterinfo.get("alternativephonenumber").hasError("maxlength")
      ) {
        this.validationMessage.alternativephonenumbermessage = this.validationMessage.phonemaxlengthvalidmessage;
      } else {
        this.validationMessage.alternativephonenumbermessage = "";
      }
    } else if (
      this.testCenterinfosubmit &&
      !this.testCenterinfo.controls["alternativephonenumber"].value
    ) {
      this.validationMessage.alternativephonenumbermessage =
        "Phone number is requied";
    } else {
      this.validationMessage.alternativephonenumbermessage = "";
    }
  }

  faxNumberValidationMessage() {
    if (
      this.testCenterinfo.controls["faxnumber"].value &&
      this.testCenterinfosubmit
    ) {
      if (this.testCenterinfo.get("faxnumber").hasError("minlength")) {
        this.validationMessage.faxnumbermessage = this.validationMessage.phonemaxlengthvalidmessage;
      } else if (this.testCenterinfo.get("faxnumber").hasError("maxlength")) {
        this.validationMessage.faxnumbermessage = this.validationMessage.phonemaxlengthvalidmessage;
      } else {
        this.validationMessage.faxnumbermessage = "";
      }
    } else if (
      this.testCenterinfosubmit &&
      !this.testCenterinfo.controls["faxnumber"].value
    ) {
      this.validationMessage.faxnumbermessage = "Phone number is requied";
    } else {
      this.validationMessage.faxnumbermessage = "";
    }
  }

  contactprimaryValidationMessage() {
    if (
      this.testCenterinfo.controls["contactprimaryphoneNumber"].value &&
      this.testCenterinfosubmit
    ) {
      if (
        this.testCenterinfo
          .get("contactprimaryphoneNumber")
          .hasError("minlength")
      ) {
        this.validationMessage.contactprimaryphoneNumbermessage = this.validationMessage.phonemaxlengthvalidmessage;
      } else if (
        this.testCenterinfo
          .get("contactprimaryphoneNumber")
          .hasError("maxlength")
      ) {
        this.validationMessage.contactprimaryphoneNumbermessage = this.validationMessage.phonemaxlengthvalidmessage;
      } else {
        this.validationMessage.contactprimaryphoneNumbermessage = "";
      }
    } else if (
      this.testCenterinfosubmit &&
      !this.testCenterinfo.controls["contactprimaryphoneNumber"].value
    ) {
      this.validationMessage.contactprimaryphoneNumbermessage =
        "Phone number is requied";
    } else {
      this.validationMessage.contactprimaryphoneNumbermessage = "";
    }
  }

  contactsecValidationMessage() {
    if (
      this.testCenterinfo.controls["contactsecondaryphoneNumber"].value &&
      this.testCenterinfosubmit
    ) {
      if (
        this.testCenterinfo
          .get("contactsecondaryphoneNumber")
          .hasError("minlength")
      ) {
        this.validationMessage.contactsecondaryphoneNumbermessage = this.validationMessage.phonemaxlengthvalidmessage;
      } else if (
        this.testCenterinfo
          .get("contactsecondaryphoneNumber")
          .hasError("maxlength")
      ) {
        this.validationMessage.contactsecondaryphoneNumbermessage = this.validationMessage.phonemaxlengthvalidmessage;
      } else {
        this.validationMessage.contactsecondaryphoneNumbermessage = "";
      }
    } else if (
      this.testCenterinfosubmit &&
      !this.testCenterinfo.controls["contactsecondaryphoneNumber"].value
    ) {
      this.validationMessage.contactsecondaryphoneNumbermessage =
        "Phone number is requied";
    } else {
      this.validationMessage.contactsecondaryphoneNumbermessage = "";
    }
  }

  noLogout() {
    this.closemodel();
    document.getElementById("closepopup").click();
    this.testCenterinfo.controls["newpassword"].setValue("");
    this.testCenterinfo.controls["oldPassword"].setValue("");
    this.testCenterinfo.controls["confirmpassword"].setValue("");
    this.profileErrorMessage = "";
    this.profileUpdateMessage = this.basicinfotext.updatedSuccessfully;
    setTimeout(() => {
      this.profileUpdateMessage = "";
    }, 5000);
    this.viewTestCenter();
  }

  updateTcProfile(testCenterinfo) {
    this.testCenterinfosubmit = true;
    if (
      testCenterinfo.get("zipcode").value &&
      testCenterinfo.get("zipcode").value.length != this.ziplength
    ) {
      this.ziperror = true;
      return;
    }
    this.updateTestCenter = true;
    let flag = true;
    this.compareHrsValid = this.checkLunchWorkhrValidation();
    if (this.secondaryEamilList && this.secondaryEamilList.length > 0) {
      for (let index = 0; index < this.secondaryEamilList.length; index++) {
        if (
          this.secondaryEamilList[index].email &&
          !this.secondaryEamilList[index].email.match(environment.emailPattern)
        ) {
          flag = false;
          this.secondaryEamilList[index].valid = false;
        }
      }
    } else {
      this.secondaryEamilList = [];
    }

    if (this.compareHrsValid) {
      flag = false;
    }
    if (this.hoursList && this.hoursList.length > 0) {
      for (let index = 0; index < this.hoursList.length; index++) {
        if (this.hoursList[index].workHourType == "") {
          flag = false;
        }
        if (
          !this.hoursList[index].monDay &&
          !this.hoursList[index].tueDay &&
          !this.hoursList[index].wedDay &&
          !this.hoursList[index].thuDay &&
          !this.hoursList[index].friDay &&
          !this.hoursList[index].satDay &&
          !this.hoursList[index].sunDay
        ) {
          this.hoursList[index].daysvalid = true;
          flag = false;
        }
        if (this.hoursList[index].fromHour == "") {
          this.hoursList[index].fromHourvalid = true;
          flag = false;
        }
        if (this.hoursList[index].toHour == "") {
          this.hoursList[index].toHourvalid = true;
          flag = false;
        }
      }
      if (!flag) {
        this.profileUpdateMessage = "";
        this.profileErrorMessage =
          "Please address the highlighted areas, then try again.";
        this.scrollTop("hourscroll");
        setTimeout(() => {
          this.profileErrorMessage = "";
        }, 5000);
        this.updateTestCenter = false;
        this.disableUpdate = true;
        return;
      }
    }

    if (this.newholidaylist.length > 0) {
      for (let index = 0; index < this.newholidaylist.length; index++) {
        if (!this.newholidaylist[index].holidayName) {
          flag = false;
          this.newholidaylist[index].reasonvalid = true;
          this.errtab = this.newholidaylist[index].holidayYear;
          this.scrollTop("holidayScroll");
          this.updateTestCenter = false;
          break;
        }
        if (!this.newholidaylist[index].holidayDate.date) {
          flag = false;
          this.newholidaylist[index].validDate = true;
          this.errtab = this.newholidaylist[index].holidayYear;
          this.scrollTop("holidayScroll");
          this.updateTestCenter = false;
          break;
        } else if (
          this.newholidaylist[index].holidayDate &&
          this.newholidaylist[index].holidayDate.date &&
          this.newholidaylist[index].holidayDate.date.year
        ) {
          for (let i = 0; i < this.holidayList.length; i++) {
            const date =
              this.newholidaylist[index].holidayDate.date.year +
              "-" +
              this.newholidaylist[index].holidayDate.date.month +
              "-" +
              this.newholidaylist[index].holidayDate.date.day;
            if (
              new Date(date).toDateString() ==
                new Date(this.holidayList[i].holidayDate).toDateString() &&
              this.holidayList[index].active
            ) {
              flag = false;
              this.newholidaylist[index].validDate = true;
              this.errtab = this.newholidaylist[index].holidayYear;
              this.profileUpdateMessage = "";
              this.profileErrorMessage =
                "Selected date already exists in holiday list";
              this.scrollTop("holidayScroll");
              setTimeout(() => {
                this.profileErrorMessage = "";
              }, 5000);
              this.updateTestCenter = false;
              return;
            }
          }
        }
      }
    }

  console.log(this.testCenterinfo.valid, 'this.testCenterinfo.valid');
    // if (this.testCenterinfo.valid) {
    if (
      this.testCenterinfo.get("oldPassword").value ||
      this.testCenterinfo.get("newpassword").value
    ) {
      if (
        this.testCenterinfo.get("oldPassword").value &&
        this.testCenterinfo.get("newpassword").value
      ) {
        const changepasswordObj = {
          oldPassword: this.testCenterinfo.get("oldPassword").value,
          password: this.testCenterinfo.get("newpassword").value,
          confirmPassword: this.testCenterinfo.get("confirmpassword").value,
        };
        this.appservice.changepassword(changepasswordObj).subscribe(
          (res) => {
            if (res && res["status"] && res["status"]["status"] == 200) {
              this.saveBasicProfile(testCenterinfo, flag, true);
              this.backendIssue = res["status"].msg;
              this.openModal(this.backendissuePopup);
            } else if (res && res["status"] && res["status"]["status"] == 245) {
              this.backendIssue = this.basicinfotext.validCurPass;
              this.openModal(this.backendissuePopup);
            } else if (res && res["status"] && res["status"]["status"] == 244) {
              this.backendIssue = this.basicinfotext.curAndNewNotSame;
              this.openModal(this.backendissuePopup);
            } else if (res && res["status"] && res["status"]["status"] == 229) {
              this.backendIssue = this.resettext.mismatch;
              this.openModal(this.backendissuePopup);
            } else if (res && res["status"] && res["status"]["status"] == 243) {
              this.backendIssue = this.resettext.passworsConstr;
              this.openModal(this.backendissuePopup);
            }
          },
          (err) => {
            this.appservice.sessionOut(err);
            this.updateTestCenter = false;
          }
        );
      } else {
        this.backendIssue = "Incomplete change password details";
        this.openModal(this.backendissuePopup);
      }
    } else {
        this.saveBasicProfile(this.testCenterinfo.value, flag, false);
    }
    // }
  }

  scrollTop(value) {
    this.updateTestCenter = false;
    document.getElementById(value).scrollIntoView({ behavior: "smooth" });
  }

  checkConfirmpwd(value) {
    if (
      this.testCenterinfo.get("confirmpassword").value &&
      this.testCenterinfo.get("newpassword").value
    ) {
      if (
        this.testCenterinfo.get("confirmpassword").value ==
        this.testCenterinfo.get("newpassword").value
      ) {
        this.validationMessage.confirmvalidationFlag = false;
      } else {
        this.validationMessage.confirmvalidationFlag = true;
      }
    } else {
      this.validationMessage.confirmvalidationFlag = false;
    }
  }

  checkEmailValidationMessage(value) {
    if (this.testCenterinfosubmit) {
      if (value.toString().trim()) {
        const email = value.toString().trim();
        if (email.match(environment.emailPattern)) {
          this.validationMessage.primaryEmailValidationmessage = "";
        } else {
          this.validationMessage.primaryEmailValidationmessage = this.validationMessage.validEmail;
        }
      } else if (!value.toString().trim()) {
        this.validationMessage.primaryEmailValidationmessage = this.validationMessage.emailid;
      } else {
        this.validationMessage.primaryEmailValidationmessage = "";
      }
    }
  }

  checkTestcenterUrl(value) {
    if (this.testCenterinfosubmit) {
      if (
        this.testCenterinfo.controls["testCenterUrl"].value.toString().trim()
      ) {
        if (
          !this.testCenterinfo.controls["testCenterUrl"].value
            .toString()
            .trim()
            .match(environment.websitePattern)
        ) {
          this.validationMessage.testCenterUrlMessage = this.validationMessage.testCenterValidUrl;
        } else {
          this.validationMessage.testCenterUrlMessage = "";
        }
      } else if (
        !this.testCenterinfo.controls["testCenterUrl"].value.toString().trim()
      ) {
        this.validationMessage.testCenterUrlMessage = this.validationMessage.testCenterUrl;
      } else {
        this.validationMessage.testCenterUrlMessage = "";
      }
    }
  }

  emailPatternValidation(data): boolean {
    if (data && data != null) {
      const email = data.toString().trim();
      if (email.match(environment.emailPattern)) {
        return true;
      }
      return false;
    }
    return false;
  }

  requiredValidation(data): boolean {
    if (data && data != null) {
      return true;
    }
    return false;
  }

  openModal(template: TemplateRef<any>) {
    this.updateTestCenter = false;
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  changepwd(value) {
    this.changepwdsubmited = true;
    this.changepasswordflag = 0;
    if (value.valid) {
      if (
        this.changepassword.get("newpassword").value ==
        this.changepassword.get("confirmpassword").value
      ) {
        const data = {
          oldPassword: this.changepassword.controls["oldPassword"].value,
          password: this.changepassword.controls["newpassword"].value,
          confirmPassword: this.changepassword.controls["confirmpassword"]
            .value,
        };
        this.appservice.changepassword(data).subscribe(
          (res) => {
            if (res && res["status"] && res["status"]["status"] == 200) {
              this.changepasswordmessage = this.basicinfotext.confirmPasswordSame;
              this.modalRef = this.modalService.show(this.changepwdpopup);
              this.changepasswordflag = 1;
            } else {
              this.changepasswordmessage = res["status"]["msg"];
              this.modalRef = this.modalService.show(this.changepwdpopup);
              this.changepasswordflag = 2;
            }
          },
          (err) => {
            this.appservice.sessionOut(err);
          }
        );
      } else {
        this.changepasswordmessage = this.basicinfotext.confirmPasswordSame;
        this.changepasswordflag = 3;
        this.modalRef = this.modalService.show(this.changepwdpopup);
      }
    }
  }

  addNewShift() {
    if (this.hoursList && this.hoursList.length > 0) {
      for (let index = 0; index < this.hoursList.length; index++) {
        if (this.hoursList[index].workHourType == "") {
          return;
        }
        if (
          !this.hoursList[index].monDay &&
          !this.hoursList[index].tueDay &&
          !this.hoursList[index].wedDay &&
          !this.hoursList[index].thuDay &&
          !this.hoursList[index].friDay &&
          !this.hoursList[index].satDay &&
          !this.hoursList[index].sunDay
        ) {
          this.hoursList[index].daysvalid = true;
          return;
        }
        if (this.hoursList[index].fromHour == "") {
          this.hoursList[index].fromHourvalid = true;
          return;
        }
        if (this.hoursList[index].toHour == "") {
          this.hoursList[index].toHourvalid = true;
          return;
        }
      }
      this.hoursList.push(this.buildDefaultWorkShift());
    }
  }

  changeClosedStatus(value, ind) {
    this.holidayList[ind].closed = !this.holidayList[ind].closed;
  }

  changeNewClosedStatus(value, ind) {
    this.newholidaylist[ind].closed = !this.newholidaylist[ind].closed;
  }

  resetFromTime(index) {
    this.disableUpdate = false;
    this.hoursList[index].fromHourvalid = false;

    if (this.hoursList[index].fromHour) {
      this.createTimeArray(
        this.hoursList[index].fromHour,
        "from",
        this.hoursList[index].toHour,
        index,
        "change"
      );
    }
    this.createWrkingList(this.hoursList);
    this.compareHrsValid = this.checkLunchWorkhrValidation();
  }

  resetToTime(index) {
    this.disableUpdate = false;
    this.hoursList[index].toHourvalid = false;
    this.createWrkingList(this.hoursList);
    this.compareHrsValid = this.checkLunchWorkhrValidation();
  }
  typeInput() {
    this.disableUpdate = false;
  }

  createTimeArray(fromvalue, type, tovalue, i, runType) {
    const fromIndex = this.fromTimeArray.indexOf(fromvalue);
    const toIndex = this.fromTimeArray.indexOf(tovalue);
    if (type == "from") {
      if (tovalue && tovalue != "") {
        if (toIndex < fromIndex) {
          if (runType == "change") {
            this.hoursList[i].toHour = "";
          }
        }
      }
      this.hoursList[i].toTimeArray = this.fromTimeArray.slice();
      this.hoursList[i].toTimeArray.splice(0, fromIndex);
    }
  }

  findHours(value, type): { hour: number; min: number } {
    let hours = 0;
    let min = 0;
    const hoursLength =
      value && value.indexOf(":") != -1 ? value.toString().split(":") : null;
    if (hoursLength && hoursLength.length > 1) {
      const minutesLength =
        hoursLength[1] && hoursLength[1].indexOf(" ") != -1
          ? hoursLength[1].toString().split(" ")
          : null;
      const hoursFirstChar = hoursLength[0].toString().charAt(0);
      hours =
        hoursFirstChar == 0
          ? +hoursLength[0].toString().charAt(1)
          : +hoursLength[0];
      if (minutesLength && minutesLength.length > 0) {
        if (minutesLength[1] && minutesLength[1] == "PM" && hours < 12) {
          hours = +hours + 12;
        }
        const minutesFirstChar = minutesLength[0].toString().charAt(0);
        min =
          minutesFirstChar == 0
            ? +minutesLength[0].toString().charAt(1)
            : +minutesLength[0];
      }
    }

    if (type == "from") {
      if (min == 45) {
        min = 0;
        hours += 1;
      } else {
        min += 15;
      }
    }
    return { hour: +hours, min: +min };
  }

  private buildDefaultWorkShift(): Record<string, any> {
    return {
      workHourType: "work",
      id: "",
      fromHour: "",
      daysvalid: false,
      fromHourvalid: false,
      toHour: "",
      toHourvalid: false,
      monDay: false,
      tueDay: false,
      wedDay: false,
      thuDay: false,
      friDay: false,
      satDay: false,
      sunDay: false,
      active: true,
      deleted: false,
      toTimeArray: [],
    };
  }

  private applyHighlightedDaysForShift(index: number): void {
    if (
      this.hoursList[index].monDay ||
      this.hoursList[index].monDay == "true"
    ) {
      this.addhighliteddays(index, "mon", true);
    }
    if (
      this.hoursList[index].tueDay ||
      this.hoursList[index].tueDay == "true"
    ) {
      this.addhighliteddays(index, "tue", true);
    }
    if (
      this.hoursList[index].wedDay ||
      this.hoursList[index].wedDay == "true"
    ) {
      this.addhighliteddays(index, "wed", true);
    }
    if (
      this.hoursList[index].thuDay ||
      this.hoursList[index].thuDay == "true"
    ) {
      this.addhighliteddays(index, "thu", true);
    }
    if (
      this.hoursList[index].friDay ||
      this.hoursList[index].friDay == "true"
    ) {
      this.addhighliteddays(index, "fri", true);
    }
    if (
      this.hoursList[index].satDay ||
      this.hoursList[index].satDay == "true"
    ) {
      this.addhighliteddays(index, "sat", true);
    }
    if (
      this.hoursList[index].sunDay ||
      this.hoursList[index].sunDay == "true"
    ) {
      this.addhighliteddays(index, "sun", true);
    }
  }

  private buildDefaultBusinessDaysWrkList(): Map<number, Record<string, any>> {
    return new Map([
      [
        1,
        {
          day: "Monday",
          type: "mon",
          workHours: "Closed",
          lunchHours: "-",
          fromWorkHour: "",
          toWorkHour: "",
          fromLunchHour: "",
          toLunchHour: "",
        },
      ],
      [
        2,
        {
          day: "Tuesday",
          type: "tue",
          workHours: "Closed",
          lunchHours: "-",
          fromWorkHour: "",
          toWorkHour: "",
          fromLunchHour: "",
          toLunchHour: "",
        },
      ],
      [
        3,
        {
          day: "Wednesday",
          type: "wed",
          workHours: "Closed",
          lunchHours: "-",
          fromWorkHour: "",
          toWorkHour: "",
          fromLunchHour: "",
          toLunchHour: "",
        },
      ],
      [
        4,
        {
          day: "Thusday",
          type: "thu",
          workHours: "Closed",
          lunchHours: "-",
          fromWorkHour: "",
          toWorkHour: "",
          fromLunchHour: "",
          toLunchHour: "",
        },
      ],
      [
        5,
        {
          day: "Friday",
          type: "fri",
          workHours: "Closed",
          lunchHours: "-",
          fromWorkHour: "",
          toWorkHour: "",
          fromLunchHour: "",
          toLunchHour: "",
        },
      ],
      [
        6,
        {
          day: "Saturday",
          type: "sat",
          workHours: "Closed",
          lunchHours: "-",
          fromWorkHour: "",
          toWorkHour: "",
          fromLunchHour: "",
          toLunchHour: "",
        },
      ],
      [
        7,
        {
          day: "Sunday",
          type: "sun",
          workHours: "Closed",
          lunchHours: "-",
          fromWorkHour: "",
          toWorkHour: "",
          fromLunchHour: "",
          toLunchHour: "",
        },
      ],
    ]);
  }

  checkbusinesswrkhours(index) {
    this.businessDaysWrkList = this.buildDefaultBusinessDaysWrkList();
    if (this.hoursList[index].workHourType == "work") {
      this.applyHighlightedDaysForShift(index);
    }

    if (this.hoursList[index].workHourType == "lunch") {
      this.applyHighlightedDaysForShift(index);
    }

    this.createWrkingList(this.hoursList);
  }

  checkvalue(fromhour, tohour, type): string {
    if (fromhour) {
      if (tohour) {
        return fromhour + " to " + tohour;
      } else {
        return fromhour + " to -";
      }
    } else if (tohour) {
      if (fromhour) {
        return fromhour + " to " + tohour;
      } else {
        return "- to " + tohour;
      }
    }
    if (type == "work") {
      return "Closed";
    } else if (type == "lunch") {
      return "-";
    }
  }
  addhighliteddays(index, type, value) {
    let availableDay = false;
    let availableWorkType = false;
    let availableLunchType = false;
    this.hoursList[index].daysvalid = false;
    if (this.hoursList[index].workHourType == "work") {
      if (this.wrkhoursList != null && this.wrkhoursList.length > 0) {
        for (let i = 0; i < this.wrkhoursList.length; i++) {
          if (this.wrkhoursList[i].type == type) {
            availableDay = true;
            if (this.wrkhoursList[i].index != index) {
              if (type == "mon") {
                this.hoursList[this.wrkhoursList[i].index].monDay = false;
              } else if (type == "tue") {
                this.hoursList[this.wrkhoursList[i].index].tueDay = false;
              } else if (type == "wed") {
                this.hoursList[this.wrkhoursList[i].index].wedDay = false;
              } else if (type == "thu") {
                this.hoursList[this.wrkhoursList[i].index].thuDay = false;
              } else if (type == "fri") {
                this.hoursList[this.wrkhoursList[i].index].friDay = false;
              } else if (type == "sat") {
                this.hoursList[this.wrkhoursList[i].index].satDay = false;
              } else if (type == "sun") {
                this.hoursList[this.wrkhoursList[i].index].sunDay = false;
              }
              this.wrkhoursList[i].index = index;
            } else {
              this.wrkhoursList.splice(i, 1);
            }
          }
        }
        if (!availableDay) {
          this.wrkhoursList.push({ type: type, index: index });
        }
      } else {
        this.wrkhoursList.push({ type: type, index: index });
      }
    }

    if (this.hoursList[index].workHourType == "lunch") {
      if (this.lunchhoursList != null && this.lunchhoursList.length > 0) {
        for (let ii = 0; ii < this.lunchhoursList.length; ii++) {
          if (this.lunchhoursList[ii].type == type) {
            availableDay = true;
            if (this.lunchhoursList[ii].index != index) {
              if (type == "mon") {
                this.hoursList[this.lunchhoursList[ii].index].monDay = false;
              } else if (type == "tue") {
                this.hoursList[this.lunchhoursList[ii].index].tueDay = false;
              } else if (type == "wed") {
                this.hoursList[this.lunchhoursList[ii].index].wedDay = false;
              } else if (type == "thu") {
                this.hoursList[this.lunchhoursList[ii].index].thuDay = false;
              } else if (type == "fri") {
                this.hoursList[this.lunchhoursList[ii].index].friDay = false;
              } else if (type == "sat") {
                this.hoursList[this.lunchhoursList[ii].index].satDay = false;
              } else if (type == "sun") {
                this.hoursList[this.lunchhoursList[ii].index].sunDay = false;
              }
              this.lunchhoursList[ii].index = index;
            } else {
              this.lunchhoursList.splice(ii, 1);
            }
          }
        }
        if (!availableDay) {
          this.lunchhoursList.push({ type: type, index: index });
        }
      } else {
        this.lunchhoursList.push({ type: type, index: index });
      }
    }

    for (let index = 0; index < this.hoursList.length; index++) {
      if (this.hoursList[index].workHourType == "lunch") {
        availableLunchType = true;
      }
      if (this.hoursList[index].workHourType == "work") {
        availableWorkType = true;
      }
    }
    if (!availableLunchType) {
      this.lunchhoursList = [];
    }
    if (!availableWorkType) {
      this.wrkhoursList = [];
    }
    this.createWrkingList(this.hoursList);
  }

  storeIndex(index, day, flag) {
    this.disableUpdate = false;
    if (this.hoursList[index].workHourType != "") {
      this.addhighliteddays(index, day, flag);
      const t = this;
      setTimeout(function () {
        t.businessDaysWrkList = t.buildDefaultBusinessDaysWrkList();
        t.createWrkingList(t.hoursList);
      }, 500);
    }
    // else {
    //   this.hoursList[index].monDay = false;
    // }
  }

  removehourslist(index) {
    this.heading = "Remove";
    this.generalvalidationMessage = "Do you want to remove the business hours?";
    this.yesornoPopuptype = "hourslist";
    this.selectedIndex = index;
    this.openModal(this.yesornoPopup);
  }

  closemodel() {
    this.modalRef.hide();
  }

  logout() {
    this.router.navigate(["/login"]);
    this.closemodel();
    sessionStorage.clear();
    localStorage.clear();
    document.getElementById("closepopup").click();
    this.appservice.revoke();
  }

  ngOnInit() {
    this.usertype = sessionStorage.getItem("usertype");
    this.navigateURL = sessionStorage.getItem("page");
    this.getLanguage();
    this.getcountry();
    this.getParkingList();
    this.viewTestCenter();

    if (
      localStorage.getItem("countryId") != null &&
      this.isIndiaCountry(localStorage.getItem("countryId"))
    ) {
      this.ziplength = 6;
      this.zipmask = "000000";
      this.ziplabel = "Pin code";
    } else if (
      localStorage.getItem("countryId") != null &&
      this.isUnitedStatesCountry(localStorage.getItem("countryId"))
    ) {
      this.ziplength = 5;
      this.zipmask = "00000";
      this.ziplabel = "Zip code";
    }
  }

  ngAfterViewInit() {
    this.testCenterinfo.valueChanges.subscribe((val) => {
      this.formValueChange = true;
    });
  }
  getLanguage() {
    this.appservice.getlang().subscribe((res) => {
      if (res["validationMessage"] && res["basicInfo"]) {
        this.validationMessage = res["validationMessage"];
        this.basicinfotext = res["basicInfo"];
        this.resettext = res["resetPage"];
        this.signintext = res["signin"];
      }
    });
  }

  getNotificationContent(tcId) {
    this.appservice.getNotifcationContent(tcId, true).subscribe((res) => {
      if (res && res["entity"] && res["entity"].length > 0) {
        this.patientTextEmailContent = true;
      }
    });
  }

  viewTestCenter() {
    let data = {};
    if (sessionStorage.getItem("usertype") == "1") {
      data = {
        tcId: sessionStorage.getItem("testId"),
      };
    }
    this.appservice.viewtestcenterwithdata(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] == 200) {
          if (res["entity"]) {
            localStorage.setItem("testCenterId", res["entity"]["id"]);
            localStorage.setItem(
              "countryId",
              res["entity"] &&
                res["entity"].address &&
                res["entity"].address.country
                ? res["entity"].address.country.id
                : ""
            );
            this.testCenterId = localStorage.getItem("testCenterId");
            this.testCenter = res["entity"];

            if (this.testCenter && this.testCenter.createdOn) {
              const time = this.testCenter.createdOn.toString().split(" ");
              const utcdate = this.appservice.setLocaldatetime(
                time[0],
                time[1]
              );
              this.testCenterinfo.controls["testcentername"].setValue(
                this.testCenter.name
              );
              if (this.testCenter.name) {
                localStorage.setItem("testCenterName", this.testCenter.name);
              }
              if (this.testCenter && this.testCenter.name) {
                this.supportService.testCenterName.next(this.testCenter.name);
                this.supportService.testCenterNameDropdown.next(
                  this.testCenter.name
                );
              } else if (!this.testCenter || !this.testCenter.name) {
                setTimeout(() => {
                  this.supportService.testCenterName.next("Imaging Center");
                  this.supportService.testCenterNameDropdown.next("IC Admin");
                }, 500);
              }

              this.testCenterinfo.controls["nipId"].setValue(
                this.testCenter.nipId
              );
              this.testCenterinfo.controls["dateEnrolled"].setValue(
                this.datepipe.transform(utcdate)
              );
              this.testCenterinfo.controls["mainEmail"].setValue(
                this.testCenter.mainEmail
              );
              this.testCenterinfo.controls["taxNumber"].setValue(
                this.testCenter.taxId
              );
              this.lat = +this.testCenter.latitude;
              this.lng = +this.testCenter.longitude;

              if (this.testCenter.address && this.testCenter.address.country) {
                this.visibleHoliday = true;
                this.testCenterinfo.controls["country"].setValue(
                  this.testCenter.address.country.id
                );
                const tcCountryCode =
                  this.isUnitedStatesCountry(this.testCenter.address.country.id)
                    ? "US"
                    : "IN";
                localStorage.setItem("country_code", tcCountryCode);
                // this.getStateList(this.testCenter.address.country.id);
                // this.getHolidayList();
                if (
                  this.testCenter.address &&
                  this.testCenter.address.state &&
                  this.testCenter.address.state.stateCode
                ) {
                  this.supportService.stateName.next(
                    this.testCenter.address.state.state
                  );
                  localStorage.setItem(
                    "stateName",
                    this.testCenter.address.state.state
                  );
                  this.changeCountry(
                    this.testCenter.address.country.id,
                    this.testCenter.address.state.stateCode
                  );
                }
                this.addressId = this.testCenter.address.id;
                this.testCenterinfo.controls["address1"].setValue(
                  this.testCenter.address.addressLine1
                );
                this.testCenterinfo.controls["unitoraddress2"].setValue(
                  this.testCenter.address.addressLine2
                );
                this.testCenterinfo.controls["areaName"].setValue(
                  this.testCenter.address.areaName
                );
                this.testCenterinfo.controls["city"].setValue(
                  this.testCenter.address.cityName
                );
                this.testCenterinfo.controls["zipcode"].setValue(
                  this.testCenter.address.zipCode
                );
              } else {
                this.visibleHoliday = false;
                this.addressId = "";
                this.getCurrentLocation();
              }
              this.testCenterinfo.controls["primaryEmail"].setValue(
                this.testCenter.tcEmail
              );
              if (
                this.testCenter.secondaryEmail &&
                this.testCenter.secondaryEmail.length > 0
              ) {
                this.secondaryEamilList = [];
                if (this.testCenter.secondaryEmail.length > 0) {
                  for (
                    let index = 0;
                    index < this.testCenter.secondaryEmail.length;
                    index++
                  ) {
                    if (this.testCenter.secondaryEmail[index].email) {
                      if (
                        this.testCenter.secondaryEmail[index].email.match(
                          environment.emailPattern
                        )
                      ) {
                        this.secondaryEamilList.push({
                          id: this.testCenter.secondaryEmail[index].id,
                          email: this.testCenter.secondaryEmail[index].email,
                          valid: true,
                          message: "",
                        });
                      } else {
                        this.secondaryEamilList.push({
                          id: this.testCenter.secondaryEmail[index].id,
                          email: this.testCenter.secondaryEmail[index].email,
                          valid: false,
                          message: this.validationMessage.validEmail,
                        });
                      }
                    }
                  }
                }
              }

              if (this.testCenter.primaryCode) {
                this.testCenterinfo.controls["primarycountrydialcode"].setValue(
                  this.testCenter.primaryCode
                );
                this.primaryphonemask = this.appservice.checkDialCode(
                  this.testCenter.primaryCode
                );
              }
              this.testCenterinfo.controls[
                "primaryphonenumberextncode"
              ].setValue(this.testCenter.primaryExtn);
              this.testCenterinfo.controls["primaryphonenumber"].setValue(
                this.testCenter.primaryNumber
              );

              if (this.testCenter.faxCode) {
                this.testCenterinfo.controls["faxcountrydialcode"].setValue(
                  this.testCenter.faxCode
                );
                this.faxphonemask = this.appservice.checkDialCode(
                  this.testCenter.faxCode
                );
              }
              this.testCenterinfo.controls["faxnumberextncode"].setValue(
                this.testCenter.faxExtn
              );
              this.testCenterinfo.controls["faxnumber"].setValue(
                this.testCenter.faxNumber
              );

              if (this.testCenter.alternativeCode) {
                this.testCenterinfo.controls[
                  "alternativecountrydialcode"
                ].setValue(this.testCenter.alternativeCode);
                this.alternativephonemask = this.appservice.checkDialCode(
                  this.testCenter.alternativeCode
                );
              }
              this.testCenterinfo.controls["alternativephonenumber"].setValue(
                this.testCenter.alternativeNumber
              );
              this.testCenterinfo.controls[
                "alternativephonenumberextncode"
              ].setValue(this.testCenter.alternativeExtn);

              if (this.testCenter.primaryContactInfo) {
                this.testCenterinfo.controls[
                  "contactprimaryfirstName"
                ].setValue(this.testCenter.primaryContactInfo.firstName);
                this.testCenterinfo.controls["contactprimarylastName"].setValue(
                  this.testCenter.primaryContactInfo.lastName
                );
                if(sessionStorage.getItem("usertype") && sessionStorage.getItem("usertype") !== "3"){
                  this.supportService.loginUserName.next(
                    this.testCenter.primaryContactInfo.firstName +
                      " " +
                      this.testCenter.primaryContactInfo.lastName
                  );
                }
               
                if (this.testCenter.primaryContactInfo.phoneCode) {
                  this.testCenterinfo.controls[
                    "contactprimaryareaCode"
                  ].setValue(this.testCenter.primaryContactInfo.phoneCode);
                  this.primaryInfoPhoneMask = this.appservice.checkDialCode(
                    this.testCenter.primaryContactInfo.phoneCode
                  );
                }
                this.testCenterinfo.controls[
                  "contactprimaryphoneNumber"
                ].setValue(this.testCenter.primaryContactInfo.phoneNumber);
                this.testCenterinfo.controls[
                  "contactprimaryphoneNumberDialCode"
                ].setValue(this.testCenter.primaryContactInfo.phoneExtn);
                this.getFirstIndex("primary");
              }

              if (this.testCenter.secondaryContactInfo) {
                this.testCenterinfo.controls[
                  "contactsecondaryfirstName"
                ].setValue(this.testCenter.secondaryContactInfo.firstName);
                this.testCenterinfo.controls[
                  "contactsecondarylastName"
                ].setValue(this.testCenter.secondaryContactInfo.lastName);
                if (this.testCenter.secondaryContactInfo.phoneCode) {
                  this.testCenterinfo.controls[
                    "contactsecondaryareaCode"
                  ].setValue(this.testCenter.secondaryContactInfo.phoneCode);
                  this.secondaryInfoPhoneMask = this.appservice.checkDialCode(
                    this.testCenter.secondaryContactInfo.phoneCode
                  );
                }
                this.testCenterinfo.controls[
                  "contactsecondaryphoneNumber"
                ].setValue(this.testCenter.secondaryContactInfo.phoneNumber);
                this.testCenterinfo.controls[
                  "contactsecondaryphoneNumberDialCode"
                ].setValue(this.testCenter.secondaryContactInfo.phoneExtn);
                this.getFirstIndex("secondary");
              }

              if (
                this.testCenter.workingHours &&
                this.testCenter.workingHours.length > 0
              ) {
                this.hoursList = [];
                this.wrkhoursList = [];
                for (
                  let index = 0;
                  index < this.testCenter.workingHours.length;
                  index++
                ) {
                  const data = {
                    workHourType: this.testCenter.workingHours[index]
                      .workHourType,
                    id: this.testCenter.workingHours[index].id,
                    fromHour: this.testCenter.workingHours[index].fromHour,
                    daysvalid: false,
                    fromHourvalid: false,
                    toHour: this.testCenter.workingHours[index].toHour,
                    toHourvalid: false,
                    monDay: this.testCenter.workingHours[index].monDay,
                    tueDay: this.testCenter.workingHours[index].tueDay,
                    wedDay: this.testCenter.workingHours[index].wedDay,
                    thuDay: this.testCenter.workingHours[index].thuDay,
                    friDay: this.testCenter.workingHours[index].friDay,
                    satDay: this.testCenter.workingHours[index].satDay,
                    sunDay: this.testCenter.workingHours[index].sunDay,
                    active: true,
                    deleted: false,
                    toTimeArray: [],
                  };
                  this.hoursList.push(data);

                  this.createTimeArray(
                    this.hoursList[index].fromHour,
                    "from",
                    this.hoursList[index].toHour,
                    index,
                    "init"
                  );

                  if (this.hoursList[index].workHourType == "work") {
                    if (
                      this.hoursList[index].monDay ||
                      this.hoursList[index].monDay == "true"
                    ) {
                      this.wrkhoursList.push({ type: "mon", index: index });
                    }
                    if (
                      this.hoursList[index].tueDay ||
                      this.hoursList[index].tueDay == "true"
                    ) {
                      this.wrkhoursList.push({ type: "tue", index: index });
                    }
                    if (
                      this.hoursList[index].wedDay ||
                      this.hoursList[index].wedDay == "true"
                    ) {
                      this.wrkhoursList.push({ type: "wed", index: index });
                    }
                    if (
                      this.hoursList[index].thuDay ||
                      this.hoursList[index].thuDay == "true"
                    ) {
                      this.wrkhoursList.push({ type: "thu", index: index });
                    }
                    if (
                      this.hoursList[index].friDay ||
                      this.hoursList[index].friDay == "true"
                    ) {
                      this.wrkhoursList.push({ type: "fri", index: index });
                    }
                    if (
                      this.hoursList[index].satDay ||
                      this.hoursList[index].satDay == "true"
                    ) {
                      this.wrkhoursList.push({ type: "sat", index: index });
                    }
                    if (
                      this.hoursList[index].sunDay ||
                      this.hoursList[index].sunDay == "true"
                    ) {
                      this.wrkhoursList.push({ type: "sun", index: index });
                    }
                  }

                  if (this.hoursList[index].workHourType == "lunch") {
                    if (
                      this.hoursList[index].monDay ||
                      this.hoursList[index].monDay == "true"
                    ) {
                      this.lunchhoursList.push({ type: "mon", index: index });
                    }
                    if (
                      this.hoursList[index].tueDay ||
                      this.hoursList[index].tueDay == "true"
                    ) {
                      this.lunchhoursList.push({ type: "tue", index: index });
                    }
                    if (
                      this.hoursList[index].wedDay ||
                      this.hoursList[index].wedDay == "true"
                    ) {
                      this.lunchhoursList.push({ type: "wed", index: index });
                    }
                    if (
                      this.hoursList[index].thuDay ||
                      this.hoursList[index].thuDay == "true"
                    ) {
                      this.lunchhoursList.push({ type: "thu", index: index });
                    }
                    if (
                      this.hoursList[index].friDay ||
                      this.hoursList[index].friDay == "true"
                    ) {
                      this.lunchhoursList.push({ type: "fri", index: index });
                    }
                    if (
                      this.hoursList[index].satDay ||
                      this.hoursList[index].satDay == "true"
                    ) {
                      this.lunchhoursList.push({ type: "sat", index: index });
                    }
                    if (
                      this.hoursList[index].sunDay ||
                      this.hoursList[index].sunDay == "true"
                    ) {
                      this.lunchhoursList.push({ type: "sun", index: index });
                    }
                  }
                }
                this.createWrkingList(this.hoursList);
              } else {
                this.hoursList.push(this.buildDefaultWorkShift());
              }

              this.testCenterinfo.controls["crossStreet"].setValue(
                this.testCenter.crossStreet
              );
              this.testCenterinfo.controls["description"].setValue(
                this.testCenter.publicTransport
              );
              this.testCenterinfo.controls["aboutus"].setValue(
                this.testCenter.aboutUs
              );
              if (this.testCenter.parking && this.testCenter.parking.id) {
                this.testCenterinfo.controls["parking"].setValue(
                  this.testCenter.parking.id
                );
              } else {
                this.testCenterinfo.controls["parking"].setValue("default");
              }

              this.testCenterinfo.controls["testCenterUrl"].setValue(
                this.testCenter.websiteUrl
              );
              this.testCenterinfo.controls["faceBookUrl"].setValue(
                this.testCenter.fbUrl
              );
              this.testCenterinfo.controls["instagramUrl"].setValue(
                this.testCenter.instagram
              );
              this.testCenterinfo.controls["linkedInUrl"].setValue(
                this.testCenter.linkedIn
              );
              this.testCenterinfo.controls["twitterUrl"].setValue(
                this.testCenter.twitterUrl
              );
              setTimeout(() => {
                this.formValueChange = false;
              }, 500);

              // if (sessionStorage.getItem("verifymessage")) {
              //   this.profileUpdateMessage = (sessionStorage.getItem("verifymessage") && sessionStorage.getItem("verifymessage") != "undefined")? sessionStorage.getItem("verifymessage"): this.signintext.verifyMessage;
              //   setTimeout(() => {
              //     this.profileUpdateMessage = '';
              //     sessionStorage.removeItem("verifymessage");
              //   }, 4000);
              // }
            }
          } else {
            this.testCenter = {};
          }
        }

        // if (res && res["status"] && res["status"]["status"] == 238) {

        //   this.unverifiedMsg = res["status"]["msg"];
        //   this.openModal(this.unverifiedPopup);
        // }
        else {
          if (res["status"]) {
            if (res["status"]["msg"]) {
              this.backendIssue = res["status"]["msg"];
            } else if (res["status"]["status"]) {
              this.backendstatuscode = res["status"]["status"];
            }
            this.openModal(this.backendissuePopup);
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  navigate() {
    this.router.navigate(["/login"]);
  }

  checkLunchWorkhrValidation() {
    for (const entry of Array.from(this.businessDaysWrkList.entries())) {
      const value = entry[1];
      let fromWrkIndex = -1;
      let toWrkIndex = -1;
      let fromLunchIndex = -1;
      let toLunchIndex = -1;
      if (
        this.fromTimeArray &&
        this.fromTimeArray.length > 0 &&
        value["fromWorkHour"] &&
        value["toWorkHour"] &&
        value["fromLunchHour"] &&
        value["toLunchHour"]
      ) {
        fromWrkIndex = this.fromTimeArray.indexOf(value["fromWorkHour"]);
        toWrkIndex = this.fromTimeArray.indexOf(value["toWorkHour"]);
        fromLunchIndex = this.fromTimeArray.indexOf(value["fromLunchHour"]);
        toLunchIndex = this.fromTimeArray.indexOf(value["toLunchHour"]);
        if (
          fromWrkIndex > -1 &&
          toWrkIndex > -1 &&
          fromLunchIndex > -1 &&
          toLunchIndex > -1
        ) {
          if (
            fromWrkIndex >= fromLunchIndex ||
            fromLunchIndex > toWrkIndex ||
            fromWrkIndex > toLunchIndex ||
            toLunchIndex >= toWrkIndex ||
            fromLunchIndex > toLunchIndex
          ) {
            return true;
          }
        }
      }
    }
    return false;
  }

  createWrkingList(data) {
    if (data && data.length > 0) {
      for (let index = 0; index < data.length; index++) {
        for (const entry of Array.from(this.businessDaysWrkList.entries())) {
          const key = entry[0];
          const value = entry[1];
          if (key == 1) {
            if (data[index].monDay && data[index].workHourType == "work") {
              value["fromWorkHour"] = data[index].fromHour;
              value["toWorkHour"] = data[index].toHour;
              value["workHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
            if (data[index].monDay && data[index].workHourType == "lunch") {
              value["fromLunchHour"] = data[index].fromHour;
              value["toLunchHour"] = data[index].toHour;
              value["lunchHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
          }
          if (key == 2) {
            if (data[index].tueDay && data[index].workHourType == "work") {
              value["fromWorkHour"] = data[index].fromHour;
              value["toWorkHour"] = data[index].toHour;
              value["workHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
            if (data[index].tueDay && data[index].workHourType == "lunch") {
              value["fromLunchHour"] = data[index].fromHour;
              value["toLunchHour"] = data[index].toHour;
              value["lunchHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
          }
          if (key == 3) {
            if (data[index].wedDay && data[index].workHourType == "work") {
              value["fromWorkHour"] = data[index].fromHour;
              value["toWorkHour"] = data[index].toHour;
              value["workHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
            if (data[index].wedDay && data[index].workHourType == "lunch") {
              value["fromLunchHour"] = data[index].fromHour;
              value["toLunchHour"] = data[index].toHour;
              value["lunchHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
          }
          if (key == 4) {
            if (data[index].thuDay && data[index].workHourType == "work") {
              value["fromWorkHour"] = data[index].fromHour;
              value["toWorkHour"] = data[index].toHour;
              value["workHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
            if (data[index].thuDay && data[index].workHourType == "lunch") {
              value["fromLunchHour"] = data[index].fromHour;
              value["toLunchHour"] = data[index].toHour;
              value["lunchHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
          }
          if (key == 5) {
            if (data[index].friDay && data[index].workHourType == "work") {
              value["fromWorkHour"] = data[index].fromHour;
              value["toWorkHour"] = data[index].toHour;
              value["workHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
            if (data[index].friDay && data[index].workHourType == "lunch") {
              value["fromLunchHour"] = data[index].fromHour;
              value["toLunchHour"] = data[index].toHour;
              value["lunchHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
          }
          if (key == 6) {
            if (data[index].satDay && data[index].workHourType == "work") {
              value["fromWorkHour"] = data[index].fromHour;
              value["toWorkHour"] = data[index].toHour;
              value["workHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
            if (data[index].satDay && data[index].workHourType == "lunch") {
              value["fromLunchHour"] = data[index].fromHour;
              value["toLunchHour"] = data[index].toHour;
              value["lunchHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
          }
          if (key == 7) {
            if (data[index].sunDay && data[index].workHourType == "work") {
              value["fromWorkHour"] = data[index].fromHour;
              value["toWorkHour"] = data[index].toHour;
              value["workHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
            if (data[index].sunDay && data[index].workHourType == "lunch") {
              value["fromLunchHour"] = data[index].fromHour;
              value["toLunchHour"] = data[index].toHour;
              value["lunchHours"] = this.checkvalue(
                data[index].fromHour,
                data[index].toHour,
                data[index].workHourType
              );
            }
          }
        }
      }
    } else {
      this.businessDaysWrkList = this.buildDefaultBusinessDaysWrkList();
    }
  }

  // timeAdjust(time): string {
  //   if (time && time.indexOf(':') > -1) {
  //     var data = time.toString().split(':');
  //     var flag = '';
  //     if (data && data.length > 1) {
  //       var spliting = data[1].toString().split(' ');
  //       if (spliting.length > 1) {
  //         var minutes = spliting[0]
  //         if (+minutes >= 0 && +minutes <= 8) {
  //           flag = data[0] + ':00 ' + spliting[1];
  //         }
  //         else if (+minutes >= 9 && +minutes <= 25) {
  //           flag = data[0] + ':15 ' + spliting[1];
  //         }
  //         else if (+minutes >= 26 && +minutes <= 35) {
  //           flag = data[0] + ':30 ' + spliting[1];
  //         }
  //         else if (+minutes >= 36 && +minutes <= 59) {
  //           flag = data[0] + ':45 ' + spliting[1];
  //         }
  //       }
  //       else {
  //         var minutes = spliting.toString().substring(0, 2);
  //         if (+minutes >= 0 && +minutes <= 8) {
  //           flag = data[0] + ':00 ' + spliting.toString().substring(2, 4);
  //         }
  //         else if (+minutes >= 9 && +minutes <= 25) {
  //           flag = data[0] + ':15 ' + spliting.toString().substring(2, 4);
  //         }
  //         else if (+minutes >= 26 && +minutes <= 35) {
  //           flag = data[0] + ':30 ' + spliting.toString().substring(2, 4);
  //         }
  //         else if (+minutes >= 36 && +minutes <= 59) {
  //           flag = data[0] + ':45 ' + spliting.toString().substring(2, 4);
  //         }
  //       }
  //     }
  //   }
  //   return flag;
  // }

  checkHour(hour): string {
    if (hour && hour.length == 2) {
      if (+hour >= 10) {
        return hour;
      } else {
        const h = hour;
        return h.toString().substring(1, 2);
      }
    } else if (hour && hour.length == 1) {
      return "0" + hour;
    }
  }

  getParkingList() {
    this.appservice.getParkingList().subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.parkingList = res["entity"];
        } else {
          this.parkingList = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getcountry() {
    this.appservice.getCountry().subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.countryList = res["entity"];
        } else {
          this.countryList = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getCurrentLocation() {
    if (window.navigator && window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(
        (showPosition) => {
          this.lat = showPosition.coords.latitude;
          this.lng = showPosition.coords.longitude;
          this.getAddressBasedonLatandLng(this.lat, this.lng, "initial");
        },
        (showError) => {
          this.showError(showError);
          this.getCurrentIPAddress();
        }
      );
    } else {
      this.getCurrentIPAddress();
    }
  }

  showError(error) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        break;
      case error.POSITION_UNAVAILABLE:
        break;
      case error.TIMEOUT:
        break;
      case error.UNKNOWN_ERROR:
        break;
    }
  }

  getCurrentIPAddress() {
    this.appservice.getCurrentIPAddress().subscribe(
      (res) => {
        if (res && res["ip"]) {
          this.getAddressBasedonCurrentIp(res["ip"]);
        }
      },
      (err) => ({})
    );
  }

  getAddressBasedonCurrentIp(ip) {
    this.appservice.getAddressBasedonCurrentIp(ip).subscribe(
      (res) => {
        if (res && res["status"] == "success" && res["lat"] && res["lon"]) {
          this.getAddressBasedonLatandLng(+res["lat"], +res["lon"], "initial");
        }
      },
      (err) => ({})
    );
  }

  getAddressBasedonLatandLng(latitude, longitude, type) {
    if (latitude && longitude) {
      this.appservice.getAddressFromGoogle(latitude, longitude).subscribe(
        (res) => {
          const address = {
            country: null,
            countryId: 0,
            administrative_area_level_1_LN: null,
            administrative_area_level_1_SN: null,
            administrative_area_level_2: null,
            locality: null,
            formatted_address: null,
            zipCode: null,
            address1: null,
          };

          if (
            res &&
            res["status"] &&
            (res["status"] == "ok" || res["status"] == "OK")
          ) {
            if (res["results"][0]) {
              let firsttime = false;
              if (res["results"][0]["formatted_address"]) {
                address.formatted_address =
                  res["results"][0]["formatted_address"];
              }
              for (
                let index = 0;
                index < res["results"][0]["address_components"].length;
                index++
              ) {
                if (
                  res["results"][0]["address_components"][index]["types"][0] ==
                  "country"
                ) {
                  if (
                    res["results"][0]["address_components"][index][
                      "long_name"
                    ] == "India" ||
                    res["results"][0]["address_components"][index][
                      "long_name"
                    ] == "india"
                  ) {
                    address.country = 1;
                    localStorage.setItem("country_code", "IN");
                    this.primaryphonemask = environment.indiaPhoneMask;
                    this.faxphonemask = environment.indiaPhoneMask;
                    this.alternativephonemask = environment.indiaPhoneMask;
                  } else if (
                    res["results"][0]["address_components"][index][
                      "long_name"
                    ] == "USA" ||
                    res["results"][0]["address_components"][index][
                      "long_name"
                    ] == "usa" ||
                    res["results"][0]["address_components"][index][
                      "long_name"
                    ] == "United States"
                  ) {
                    address.country = 2;
                    localStorage.setItem("country_code", "US");
                    this.primaryphonemask = environment.usPhoneMask;
                    this.faxphonemask = environment.usPhoneMask;
                    this.alternativephonemask = environment.usPhoneMask;
                  } else {
                    firsttime = true;
                  }
                  if (
                    address.country &&
                    (this.isIndiaCountry(address.country) || this.isUnitedStatesCountry(address.country))
                  ) {
                    this.lat = +latitude;
                    this.lng = +longitude;
                  } else {
                    if (firsttime && type == "initial") {
                      address.country = 2;
                      localStorage.setItem("country_code", "US");
                      this.primaryphonemask = environment.usPhoneMask;
                      this.faxphonemask = environment.usPhoneMask;
                      this.alternativephonemask = environment.usPhoneMask;
                    } else {
                      this.locationmessage = this.basicinfotext.notrange;
                      let lat = this.lat;
                      let lng = this.lng;
                      this.lat = 0;
                      this.lng = 0;
                      setTimeout(() => {
                        this.lat = lat;
                        this.lng = lng;
                      }, 500);
                      this.openModal(this.notRangePopup);
                      return;
                    }
                  }
                }
                if (
                  res["results"][0]["address_components"][index]["types"][0] ==
                    "administrative_area_level_1" &&
                  !firsttime
                ) {
                  address.administrative_area_level_1_SN =
                    res["results"][0]["address_components"][index][
                      "short_name"
                    ];
                  address.administrative_area_level_1_LN =
                    res["results"][0]["address_components"][index]["long_name"];
                }
                if (
                  res["results"][0]["address_components"][index]["types"][0] ==
                    "administrative_area_level_2" &&
                  !firsttime
                ) {
                  address.administrative_area_level_2 =
                    res["results"][0]["address_components"][index]["long_name"];
                }
                if (
                  res["results"][0]["address_components"][index]["types"][0] ==
                    "locality" &&
                  !firsttime
                ) {
                  address.locality =
                    res["results"][0]["address_components"][index]["long_name"];
                }

                if (
                  res["results"][0]["address_components"][index]["types"][0] ==
                    "postal_code" &&
                  !firsttime
                ) {
                  address.zipCode =
                    res["results"][0]["address_components"][index]["long_name"];
                }

                if (
                  res["results"][0]["address_components"][index]["types"][0] ==
                    "route" &&
                  !firsttime
                ) {
                  address.address1 =
                    res["results"][0]["address_components"][index]["long_name"];
                }
              }

              const data = !firsttime
                ? this.setAddressDetails(address)
                : {
                    state: "default",
                    country: 2,
                    city: "",
                    areaName: "",
                    zipCode: "",
                    address1: "",
                  };
              if (data) {
                this.testCenterinfo.controls["state"].setValue(data.state);
                this.testCenterinfo.controls["country"].setValue(data.country);
                localStorage.setItem("countryId", data.country.toString());
                this.changeCountry(data.country, data.state);
                if (address.administrative_area_level_1_LN) {
                  this.supportService.stateName.next(
                    address.administrative_area_level_1_LN
                  );
                } else {
                  this.supportService.stateName.next("");
                }
              }
            }
          }
        },
        (err) => {
          this.appservice.sessionOut(err);
          console.log(err);
        }
      );
    }
  }

  setAddressDetails(
    address
  ): {
    state: string;
    country: string;
    city: string;
    areaName: string;
    zipCode: string;
    address1: string;
  } {
    const getAddress = {
      state: "",
      country: "",
      city: "",
      areaName: "",
      zipCode: "",
      address1: "",
    };
    if (
      address.administrative_area_level_2 &&
      address.locality &&
      address.administrative_area_level_2 == address.locality
    ) {
      const splitFormateAddress = address.formatted_address
        .toString()
        .split(address.administrative_area_level_2);
      if (
        splitFormateAddress.length > 1 &&
        splitFormateAddress[0] &&
        splitFormateAddress[0].toString().indexOf(",") != -1
      ) {
        const formatedAddress = splitFormateAddress[0].toString().split(",");
        if (formatedAddress && formatedAddress.length > 1) {
          for (let index = 0; index < formatedAddress.length; index++) {
            if (
              !formatedAddress[index] ||
              formatedAddress[index] == " " ||
              formatedAddress[index] == ""
            ) {
              formatedAddress.splice(index, 1);
            }
          }

          getAddress.areaName = formatedAddress[formatedAddress.length - 1];
        }
      } else {
        getAddress.areaName = address.locality;
      }
      getAddress.city = address.administrative_area_level_2;
    }

    if (
      address.administrative_area_level_2 &&
      address.locality &&
      address.administrative_area_level_2 != address.locality
    ) {
      getAddress.city = address.administrative_area_level_2;
      getAddress.areaName = address.locality;
    }

    if (!address.administrative_area_level_2 && address.locality) {
      const splitFormateAddress1 = address.formatted_address
        .toString()
        .split(address.locality);
      if (
        splitFormateAddress1.length > 1 &&
        splitFormateAddress1[0] &&
        splitFormateAddress1[0].toString().indexOf(",") != -1
      ) {
        const formatedAddress1 = splitFormateAddress1[0].toString().split(",");
        if (formatedAddress1 && formatedAddress1.length > 1) {
          for (let index = 0; index < formatedAddress1.length; index++) {
            if (
              !formatedAddress1[index] ||
              formatedAddress1[index] == " " ||
              formatedAddress1[index] == ""
            ) {
              formatedAddress1.splice(index, 1);
            }
          }
          getAddress.areaName = formatedAddress1[formatedAddress1.length - 1];
        }
      } else {
        getAddress.areaName = address.locality;
      }
      getAddress.city = "";
    }

    if (address.administrative_area_level_2 && !address.locality) {
      const splitFormateAddress2 = address.formatted_address
        .toString()
        .split(address.administrative_area_level_2);

      if (
        splitFormateAddress2.length > 1 &&
        splitFormateAddress2[0] &&
        splitFormateAddress2[0].toString().indexOf(",") != -1
      ) {
        const formatedAddress2 = splitFormateAddress2[0].toString().split(",");
        if (formatedAddress2 && formatedAddress2.length > 1) {
          for (let index = 0; index < formatedAddress2.length; index++) {
            if (
              !formatedAddress2[index] ||
              formatedAddress2[index] == " " ||
              formatedAddress2[index] == ""
            ) {
              formatedAddress2.splice(index, 1);
            }
          }
          getAddress.areaName = formatedAddress2[formatedAddress2.length - 1];
        }
      } else {
        getAddress.areaName = address.administrative_area_level_2;
      }
      getAddress.city = address.administrative_area_level_2;
    }

    if (
      !address.administrative_area_level_2 &&
      !address.locality &&
      address.administrative_area_level_1_LN
    ) {
      const splitFormateAddress3 = address.formatted_address
        .toString()
        .split(address.administrative_area_level_1_LN);
      if (
        splitFormateAddress3.length > 1 &&
        splitFormateAddress3[0] &&
        splitFormateAddress3[0].toString().indexOf(",") != -1
      ) {
        const formatedAddress3 = splitFormateAddress3[0].toString().split(",");
        if (formatedAddress3 && formatedAddress3.length > 1) {
          for (let index = 0; index < formatedAddress3.length; index++) {
            if (
              !formatedAddress3[index] ||
              formatedAddress3[index] == " " ||
              formatedAddress3[index] == ""
            ) {
              formatedAddress3.splice(index, 1);
            }
          }
          getAddress.areaName = formatedAddress3[formatedAddress3.length - 1];
        }
      } else {
        getAddress.areaName = address.administrative_area_level_2;
      }
      getAddress.city = address.administrative_area_level_2;
    }
    getAddress.state = address.administrative_area_level_1_SN;
    getAddress.country = address.country;
    getAddress.zipCode = address.zipCode;
    getAddress.address1 = address.address1;
    return {
      state: getAddress.state,
      country: getAddress.country,
      city: getAddress.city,
      areaName: getAddress.areaName,
      zipCode: getAddress.zipCode,
      address1: getAddress.address1,
    };
  }

  getLatLngBasedOnAddress() {
    if (
      this.testCenterinfo.controls["city"].value &&
      this.testCenterinfo.controls["state"].value &&
      this.testCenterinfo.controls["state"].value != "default" &&
      this.testCenterinfo.controls["country"].value &&
      this.testCenterinfo.controls["country"].value != "default" &&
      this.testCenterinfo.controls["zipcode"].value &&
      this.testCenterinfo.controls["address1"].value
    ) {
      const searchedAddress = {
        state: "",
        country: "",
        city: "",
        areaName: "",
      };
      for (let index = 0; index < this.stateList.length; index++) {
        if (
          this.stateList[index].stateCode &&
          this.stateList[index].stateCode ==
            this.testCenterinfo.controls["state"].value
        ) {
          searchedAddress.state = this.stateList[index].state;
          this.supportService.stateName.next(searchedAddress.state);
          break;
        }
      }
      if (
        this.isIndiaCountry(this.testCenterinfo.controls["country"].value)
      ) {
        searchedAddress.country = "India";
      }
      if (
        this.isUnitedStatesCountry(this.testCenterinfo.controls["country"].value)
      ) {
        searchedAddress.country = "United States";
      }
      const formatedAddress =
        this.testCenterinfo.controls["address1"].value +
        "," +
        this.testCenterinfo.controls["areaName"].value +
        "," +
        this.testCenterinfo.controls["city"].value +
        "," +
        searchedAddress.state +
        "," +
        searchedAddress.country +
        "," +
        this.testCenterinfo.controls["zipcode"].value;
      if (formatedAddress) {
        this.getAddressBasedonAddress(formatedAddress, searchedAddress);
      }
    }
  }

  getAddressBasedonAddress(searchaddress, userAddress) {
    this.appservice.getAddressBasedonAddress(searchaddress).subscribe(
      (res) => {
        const address = {
          country: null,
          administrative_area_level_1_LN: null,
          administrative_area_level_1_SN: null,
          administrative_area_level_2: null,
          locality: null,
          formatted_address: null,
        };
        if (
          res &&
          res["status"] &&
          (res["status"] == "ok" || res["status"] == "OK")
        ) {
          if (res["results"][0]) {
            if (res["results"][0]["formatted_address"]) {
              address.formatted_address =
                res["results"][0]["formatted_address"];
            }
            for (
              let index = 0;
              index < res["results"][0]["address_components"].length;
              index++
            ) {
              if (
                res["results"][0]["address_components"][index]["types"][0] ==
                "country"
              ) {
                if (
                  res["results"][0]["address_components"][index]["long_name"] ==
                    "India" ||
                  res["results"][0]["address_components"][index]["long_name"] ==
                    "india"
                ) {
                  address.country = 1;
                }
                if (
                  res["results"][0]["address_components"][index]["long_name"] ==
                    "USA" ||
                  res["results"][0]["address_components"][index]["long_name"] ==
                    "usa" ||
                  res["results"][0]["address_components"][index]["long_name"] ==
                    "United States"
                ) {
                  address.country = 2;
                }
                if (
                  address.country &&
                  (this.isIndiaCountry(address.country) || this.isUnitedStatesCountry(address.country))
                ) {
                  this.lat = res["results"][0]["geometry"]["location"]["lat"];
                  this.lng = res["results"][0]["geometry"]["location"]["lng"];
                } else {
                  this.locationmessage = this.basicinfotext.notrange;
                  this.openModal(this.notRangePopup);
                  return;
                }
              }
              if (
                res["results"][0]["address_components"][index]["types"][0] ==
                "administrative_area_level_1"
              ) {
                address.administrative_area_level_1_SN =
                  res["results"][0]["address_components"][index]["short_name"];
                address.administrative_area_level_1_LN =
                  res["results"][0]["address_components"][index]["long_name"];
              }
              if (
                res["results"][0]["address_components"][index]["types"][0] ==
                "administrative_area_level_2"
              ) {
                address.administrative_area_level_2 =
                  res["results"][0]["address_components"][index]["long_name"];
              }
              if (
                res["results"][0]["address_components"][index]["types"][0] ==
                "locality"
              ) {
                address.locality =
                  res["results"][0]["address_components"][index]["long_name"];
              }
            }
            this.setAddressDetails(address);
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  mapClicked(value) {
    if (value && value.coords && value.coords.lat && value.coords.lng) {
      this.testCenterinfo["controls"]["areaName"].setValue("");
      this.getAddressBasedonLatandLng(value.coords.lat, value.coords.lng, "");
    }
  }

  mapDragEnd(value) {
    if (value && value.coords && value.coords.lat && value.coords.lng) {
      this.testCenterinfo["controls"]["areaName"].setValue("");
      this.getAddressBasedonLatandLng(value.coords.lat, value.coords.lng, "");
    }
  }

  changeMask(type, value) {
    if (type == "primaryphonemask") {
      this.primaryphonemask = this.appservice.checkDialCode(value);
      this.testCenterinfo.controls.primaryphonenumber.enable();
    }
    if (type == "alternativephonemask") {
      this.alternativephonemask = this.appservice.checkDialCode(value);
      this.testCenterinfo.controls.alternativephonenumber.enable();
    }
    if (type == "faxphonemask") {
      this.faxphonemask = this.appservice.checkDialCode(value);
      this.testCenterinfo.controls.faxnumber.enable();
    }
    if (type == "primaryInfoPhoneMask") {
      this.primaryInfoPhoneMask = this.appservice.checkDialCode(value);
      this.testCenterinfo.controls.contactprimaryphoneNumber.enable();
    }
    if (type == "secondaryInfoPhoneMask") {
      this.secondaryInfoPhoneMask = this.appservice.checkDialCode(value);
      this.testCenterinfo.controls.contactsecondaryphoneNumber.enable();
    }
  }
  addSecondaryEamil() {
    if (this.secondaryEamilList.length > 0) {
      const index = this.secondaryEamilList.length - 1;
      const secondaryEmail = this.secondaryEamilList[index].email;
      if (secondaryEmail) {
        if (secondaryEmail.match(environment.emailPattern)) {
          this.secondaryEamilList[index].valid = true;
          this.secondaryEamilList[index].message = "";
        } else {
          this.secondaryEamilList[index].valid = false;
          this.secondaryEamilList[
            index
          ].message = this.validationMessage.validEmail;
        }
      } else if (!secondaryEmail) {
        this.secondaryEamilList[index].valid = false;
        this.secondaryEamilList[index].message = this.validationMessage.emailid;
      }
      if (this.secondaryEamilList[index].valid == true) {
        this.secondaryEamilList.push({
          email: null,
          valid: true,
          message: this.validationMessage.emailid,
        });
      }
    } else {
      this.secondaryEamilList.push({
        email: null,
        valid: true,
        message: this.validationMessage.emailid,
      });
    }
  }
  removeSecondaryEmail(index) {
    this.heading = "Remove";
    this.generalvalidationMessage =
      "Do you want to remove the secondary email?";
    this.yesornoPopuptype = "secondaryemail";
    this.selectedIndex = index;
    this.openModal(this.yesornoPopup);
  }

  changeoption(value, index) {
    this.newholidaylist[index].closed = value;
  }

  changeholidayListoption(value, index) {
    this.holidayList[index].closed = value;
  }

  chkLength(data) {
    if (data.toString().length == 1) {
      return "0" + data.toString();
    } else {
      return data;
    }
  }

  onDateChanged(index, value) {
    let flag = false;
    if (value.jsdate) {
      for (let index = 0; index < this.holidayList.length; index++) {
        if (
          new Date(value.jsdate).toDateString() ==
            new Date(this.holidayList[index].holidayDate).toDateString() &&
          this.selectedYear == this.holidayList[index].holidayYear &&
          this.holidayList[index].active
        ) {
          flag = true;
          this.profileUpdateMessage = "";
          this.profileErrorMessage = this.basicinfotext.exists;
          setTimeout(() => {
            this.profileErrorMessage = "";
          }, 5000);
          break;
        }
      }
      if (flag) {
        this.newholidaylist[index].validDate = true;
      } else {
        this.newholidaylist[index].validDate = false;
      }
    }
  }

  resetValidation(index) {
    this.newholidaylist[index].reasonvalid = false;
  }

  setSelectedYear(year) {
    // eslint-disable-next-line no-console
    this.selectedYear = +year;
    this.errtab = +year;
    if (this.selectedYear == this.today.getFullYear()) {
      this.myDatePickerOptions = {
        dateFormat: "mmm dd, yyyy",
        minYear: +this.selectedYear,
        firstDayOfWeek: "su",
        disableUntil: {
          year: this.currentYear,
          month: this.currentMonth,
          day: this.currentDate,
        },
        maxYear: +this.selectedYear,
        showTodayBtn: true,
        showClearDateBtn: false,
        editableDateField: false,
      };
    }

    if (this.selectedYear == this.today.getFullYear() + 1) {
      this.myDatePickerOptions = {
        dateFormat: "mmm dd, yyyy",
        minYear: +this.selectedYear,
        firstDayOfWeek: "su",
        disableUntil: {
          year: this.today.getFullYear(),
          month: +"12",
          day: +"31",
        },
        maxYear: +this.selectedYear,
        showTodayBtn: false,
        showClearDateBtn: false,
        editableDateField: false,
      };
    }

    if (this.selectedYear == this.today.getFullYear() + 2) {
      this.myDatePickerOptions = {
        dateFormat: "mmm dd, yyyy",
        minYear: +this.selectedYear,
        firstDayOfWeek: "su",
        disableUntil: {
          year: this.today.getFullYear(),
          month: +"12",
          day: +"31",
        },
        maxYear: +this.selectedYear,
        showTodayBtn: false,
        showClearDateBtn: false,
        editableDateField: false,
      };
    }
  }
  addHoliday() {
    this.pushNewHoliday();
  }

  pushNewHoliday() {
    let holidayDateData;
    if (this.selectedYear == this.today.getFullYear()) {
      holidayDateData = { date: null };
    }
    if (this.selectedYear == this.today.getFullYear() + 1) {
      holidayDateData = {
        date: {
          year: this.today.getFullYear() + 1,
          month: "1",
          day: "1",
        },
      };
    }
    if (this.selectedYear == this.today.getFullYear() + 2) {
      holidayDateData = {
        date: {
          year: this.today.getFullYear() + 2,
          month: "1",
          day: "1",
        },
      };
    }
    const data = {
      deleted: false,
      active: true,
      closed: true,
      countryId: this.testCenterinfo.controls["country"].value,
     
      holidayDate: holidayDateData,
      holidatUtcDate: null,
      holidayDefault: true,
      holidayName: null,
      holidayYear: this.selectedYear,
      reasonvalid: false,
      validDate: false,
    };
    this.newholidaylist.push(data);
  }

  removeHolidayFromOriginalList(index) {
    this.heading = "Remove";
    this.generalvalidationMessage = "Do you want to remove the holiday?";
    this.yesornoPopuptype = "originalHolidayList";
    this.selectedIndex = index;
    this.openModal(this.yesornoPopup);
  }

  removeHolidayDay(index) {
    this.heading = "Remove";
    this.generalvalidationMessage = "Do you want to remove the holiday?";
    this.yesornoPopuptype = "holidaylist";
    this.selectedIndex = index;
    this.openModal(this.yesornoPopup);
  }

  changeCountry(countryid, stateid) {
    const nipControl = this.testCenterinfo.get("nipId");
    const areaNameControl = this.testCenterinfo.get("areaName");
    if (countryid) {
      if (this.isIndiaCountry(countryid)) {
        nipControl.clearValidators();
        areaNameControl.setValidators(Validators.compose([Validators.required]));
        this.testCenterinfo.controls["zipcode"].setValue(null);
        this.testCenterinfo.controls["primarycountrydialcode"].setValue("+91");
        this.primaryphonemask = "00000-00000";
        this.panMask = "A{10}";
        this.testCenterinfo.controls.primaryphonenumber.enable();
        this.ziplength = 6;
        this.zipmask = "000000";
        this.ziplabel = "Pin code";

        this.testCenterinfo.controls["alternativecountrydialcode"].setValue(
          "+91"
        );
        this.alternativephonemask = "00000-00000";
        this.testCenterinfo.controls.alternativephonenumber.enable();

        this.testCenterinfo.controls["faxcountrydialcode"].setValue("+91");
        this.faxphonemask = "00000-00000";
        this.testCenterinfo.controls.faxnumber.enable();
        this.testCenterinfo.controls["contactsecondaryareaCode"].setValue(
          "+91"
        );
        this.secondaryInfoPhoneMask = "00000-00000";
        this.testCenterinfo.controls.contactsecondaryphoneNumber.enable();
        this.testCenterinfo.controls["contactprimaryareaCode"].setValue("+91");
        this.primaryInfoPhoneMask = "00000-00000";
        this.testCenterinfo.controls.contactprimaryphoneNumber.enable();
      } else if (this.isUnitedStatesCountry(countryid)) {
        this.testCenterinfo.controls["zipcode"].setValue(null);
        nipControl.setValidators(Validators.compose([Validators.required]));
        areaNameControl.clearValidators();
        this.testCenterinfo.controls["primarycountrydialcode"].setValue("+1");
        this.primaryphonemask = "(000) 000-0000";
        this.panMask = "00-0000000";
        this.testCenterinfo.controls.primaryphonenumber.enable();
        this.ziplength = 5;
        this.zipmask = "00000";
        this.ziplabel = "Zip code";
        this.testCenterinfo.controls["alternativecountrydialcode"].setValue(
          "+1"
        );
        this.alternativephonemask = "(000) 000-0000";
        this.testCenterinfo.controls.alternativephonenumber.enable();
        this.testCenterinfo.controls["faxcountrydialcode"].setValue("+1");
        this.faxphonemask = "(000) 000-0000";
        this.testCenterinfo.controls.faxnumber.enable();
        this.testCenterinfo.controls["contactsecondaryareaCode"].setValue("+1");
        this.secondaryInfoPhoneMask = "(000) 000-0000";
        this.testCenterinfo.controls.contactsecondaryphoneNumber.enable();
        this.testCenterinfo.controls["contactprimaryareaCode"].setValue("+1");
        this.primaryInfoPhoneMask = "(000) 000-0000";
        this.testCenterinfo.controls.contactprimaryphoneNumber.enable();
      }
      nipControl.updateValueAndValidity();
      areaNameControl.updateValueAndValidity();
      this.getStateList(countryid);
      this.testCenterinfo.controls["state"].setValue(stateid);
      this.getLatLngBasedOnAddress();
      this.getHolidayList();
    }
  }

  getStateList(countryid) {
    localStorage.setItem("currentlocationcountry", countryid);
    this.appservice.getState(countryid).subscribe(
      (res) => {
        this.stateList = res["entity"];
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getHolidayList() {
    if (this.allYears && this.allYears.length > 0) {
      const data = {
        testCenterId: this.testCenter.id,
        countryId: this.testCenterinfo.get("country").value,
        year: this.allYears,
      };
      this.newholidaylist = [];
      this.appservice.getHolidayList(data).subscribe(
        (res) => {
          if (res && res["entity"]) {
            this.holidayList = [];
            const removeDuplicateDates = {};
            for (const i in res["entity"]) {
              const objTitle = res["entity"][i]["holidayStrDate"];
              removeDuplicateDates[objTitle] = res["entity"][i];
            }
            for (const i in removeDuplicateDates) {
              this.holidayList.push(removeDuplicateDates[i]);
            }

            this.visibleHoliday = true;
          } else {
            this.holidayList = [];
            this.visibleHoliday = true;
          }
        },
        (err) => {
          this.holidayList = [];
          this.visibleHoliday = false;
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  submitform() {
    const nipControl = this.testCenterinfo.get("nipId");
    if (
      this.isUnitedStatesCountry(this.testCenterinfo["controls"]["country"].value)
    ) {
      if (!this.testCenterinfo["controls"]["areaName"].value) {
        this.testCenterinfo["controls"]["areaName"].setValue(
          this.testCenterinfo.controls["city"].value
        );
      }
      nipControl.setValidators(Validators.compose([Validators.required]));
    } else {
      nipControl.clearValidators();
    }
    nipControl.updateValueAndValidity();
    document.getElementById("formsubmit").click();
  }

  changeState(stateid) {
    this.appservice.getCity(stateid).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] == 200) {
          this.cityList = res["entity"];
        } else {
          this.cityList = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
        this.cityList = [];
      }
    );
  }

  hidepassword(type) {
    if (type == "p") {
      this.passwordview = this.basicinfotext.passwordviewtxt;
    } else if (type == "cp") {
      this.confirmpasswordview = this.basicinfotext.passwordviewtxt;
    } else if (type == "np") {
      this.newpasswordview = this.basicinfotext.passwordviewtxt;
    }
  }

  viewpassword(type) {
    if (type == "p") {
      this.passwordview = this.basicinfotext.passwordviewtxt2;
    } else if (type == "cp") {
      this.confirmpasswordview = this.basicinfotext.passwordviewtxt2;
    } else if (type == "np") {
      this.newpasswordview = this.basicinfotext.passwordviewtxt2;
    }
  }

  changeCountrycode(countryid, type) {
    if (type == "primary") {
      if (countryid == "+91" || countryid == +91) {
        this.primaryphonemask = "00000-00000";
      } else if (countryid == "+1" || countryid == +1) {
        this.primaryphonemask = "(000) 000-0000";
      }
    } else if (type == "alternative") {
      if (countryid == "+91" || countryid == +91) {
        this.alternativephonemask = "00000-00000";
      } else if (countryid == "+1" || countryid == +1) {
        this.alternativephonemask = "(000) 000-0000";
      }
    } else if (type == "fax") {
      if (countryid == "+91" || countryid == +91) {
        this.faxphonemask = "00000-00000";
      } else if (countryid == "+1" || countryid == +1) {
        this.faxphonemask = "(000) 000-0000";
      }
    } else if (type == "contactprimary") {
      if (countryid == "+91" || countryid == +91) {
        this.contactprimary = "00000-00000";
      } else if (countryid == "+1" || countryid == +1) {
        this.contactprimary = "(000) 000-0000";
      }
    } else if (type == "contactsecondary") {
      if (countryid == "+91" || countryid == +91) {
        this.contactsecondary = "00000-00000";
      } else if (countryid == "+1" || countryid == +1) {
        this.contactsecondary = "(000) 000-0000";
      }
    }
  }
  getFirstIndex(type) {
    if (
      type &&
      type === "primary" &&
      this.testCenterinfo.controls["contactprimaryfirstName"].value &&
      this.testCenterinfo.controls["contactprimarylastName"].value
    ) {
      this.testCenterinfo.controls["primaryinitial"].setValue(
        this.testCenterinfo.controls["contactprimaryfirstName"].value
          .charAt(0)
          .toUpperCase() +
          this.testCenterinfo.controls["contactprimarylastName"].value
            .charAt(0)
            .toUpperCase()
      );
    } else if (
      type &&
      type === "secondary" &&
      this.testCenterinfo.controls["contactsecondaryfirstName"].value &&
      this.testCenterinfo.controls["contactsecondarylastName"].value
    ) {
      this.testCenterinfo.controls["secondaryInitial"].setValue(
        this.testCenterinfo.controls["contactsecondaryfirstName"].value
          .charAt(0)
          .toUpperCase() +
          this.testCenterinfo.controls["contactsecondarylastName"].value
            .charAt(0)
            .toUpperCase()
      );
    }
    this.testCenterinfo.updateValueAndValidity();
  }

  public charactersOnly(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[a-zA-Z\\ ]/;
      const inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
  }

  public numbersOnly(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9\\ ]/;
      const inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
  }
}
